_N_E =
(window["webpackJsonp_N_E"] = window["webpackJsonp_N_E"] || []).push([[17],{

/***/ "/F9L":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getAppStyles; });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("q1tI");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var styled_jsx_style__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("MX0m");
/* harmony import */ var styled_jsx_style__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(styled_jsx_style__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _utils_constants_ui__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("IWZK");
/* harmony import */ var _utils_styles__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("oCA+");
/* harmony import */ var _utils_theme__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("BYIe");

var __jsx = react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement;




var getAppStyles = function getAppStyles(theme) {
  var fontUrl = !Object(_utils_theme__WEBPACK_IMPORTED_MODULE_4__[/* isNotGoogleFont */ "f"])(theme["font-family"]) ? Object(_utils_theme__WEBPACK_IMPORTED_MODULE_4__[/* getFontFamilyUrl */ "d"])({
    family: theme["font-family"]
  }) : "";
  return {
    styles: __jsx(styled_jsx_style__WEBPACK_IMPORTED_MODULE_1___default.a, {
      id: "2865940685",
      dynamic: [{
        fontUrl: fontUrl
      }, theme["color-text--primary"], theme["font-family"], _utils_styles__WEBPACK_IMPORTED_MODULE_3__[/* COLORS */ "a"].whitesmoke, _utils_styles__WEBPACK_IMPORTED_MODULE_3__[/* COLORS */ "a"].blueFade, _utils_styles__WEBPACK_IMPORTED_MODULE_3__[/* COLORS */ "a"].whitesmoke, theme["color-text--primary"], theme["color-text--primary"], theme["color-text--secondary"], theme["color-primary"], theme["color-primary"], theme["bg-primary"], theme["color-error"], _utils_styles__WEBPACK_IMPORTED_MODULE_3__[/* COLORS */ "a"].dangerBorder, _utils_styles__WEBPACK_IMPORTED_MODULE_3__[/* COLORS */ "a"].warning, theme["bg-primary"], _utils_styles__WEBPACK_IMPORTED_MODULE_3__[/* COLORS */ "a"].whitesmoke, _utils_constants_ui__WEBPACK_IMPORTED_MODULE_2__[/* PHONE */ "j"] + 1, theme["bg-primary--hover"], theme["bg-primary--fade"], theme["b-primary"], theme["b-primary"], theme["b-primary"], theme["color-primary"], theme["b-primary"], theme["color-primary"], theme["color-text--primary"], theme["bg-primary--fade"], theme["bg-primary--fade"], _utils_styles__WEBPACK_IMPORTED_MODULE_3__[/* COLORS */ "a"].blue, theme["bg-primary--fade"], theme["bg-primary"], _utils_styles__WEBPACK_IMPORTED_MODULE_3__[/* COLORS */ "a"].white, theme["bg-primary--fade"], theme["bg-primary--fade"], theme["color-primary"], theme["color-primary"], theme["b-primary"], theme["color-primary"], theme["b-primary"], _utils_styles__WEBPACK_IMPORTED_MODULE_3__[/* COLORS */ "a"].white, _utils_styles__WEBPACK_IMPORTED_MODULE_3__[/* COLORS */ "a"].whitesmoke, theme["b-primary"], _utils_styles__WEBPACK_IMPORTED_MODULE_3__[/* COLORS */ "a"].disabled, _utils_styles__WEBPACK_IMPORTED_MODULE_3__[/* COLORS */ "a"].white, _utils_styles__WEBPACK_IMPORTED_MODULE_3__[/* COLORS */ "a"].disabled, _utils_styles__WEBPACK_IMPORTED_MODULE_3__[/* COLORS */ "a"].whitesmoke, _utils_styles__WEBPACK_IMPORTED_MODULE_3__[/* COLORS */ "a"].danger05, _utils_styles__WEBPACK_IMPORTED_MODULE_3__[/* COLORS */ "a"].warning05Text, _utils_styles__WEBPACK_IMPORTED_MODULE_3__[/* COLORS */ "a"].warning05, _utils_styles__WEBPACK_IMPORTED_MODULE_3__[/* COLORS */ "a"].success05, _utils_styles__WEBPACK_IMPORTED_MODULE_3__[/* COLORS */ "a"].gold05Text, _utils_styles__WEBPACK_IMPORTED_MODULE_3__[/* COLORS */ "a"].gold05, _utils_styles__WEBPACK_IMPORTED_MODULE_3__[/* COLORS */ "a"].textSecondary, _utils_constants_ui__WEBPACK_IMPORTED_MODULE_2__[/* MAX_WIDTH */ "f"], _utils_styles__WEBPACK_IMPORTED_MODULE_3__[/* COLORS */ "a"].content.secondary, _utils_styles__WEBPACK_IMPORTED_MODULE_3__[/* COLORS */ "a"].content.hover, theme["color-primary"], _utils_styles__WEBPACK_IMPORTED_MODULE_3__[/* COLORS */ "a"].blueFade, _utils_constants_ui__WEBPACK_IMPORTED_MODULE_2__[/* DESKTOP */ "e"], _utils_constants_ui__WEBPACK_IMPORTED_MODULE_2__[/* PHONE */ "j"] + 1, _utils_constants_ui__WEBPACK_IMPORTED_MODULE_2__[/* PHONE */ "j"] + 1, _utils_constants_ui__WEBPACK_IMPORTED_MODULE_2__[/* PHONE */ "j"] + 1, _utils_constants_ui__WEBPACK_IMPORTED_MODULE_2__[/* PHONE */ "j"] + 1, _utils_styles__WEBPACK_IMPORTED_MODULE_3__[/* COLORS */ "a"].blue, _utils_constants_ui__WEBPACK_IMPORTED_MODULE_2__[/* PHONE */ "j"], _utils_constants_ui__WEBPACK_IMPORTED_MODULE_2__[/* PHONE */ "j"] + 1, _utils_constants_ui__WEBPACK_IMPORTED_MODULE_2__[/* DESKTOP */ "e"], _utils_styles__WEBPACK_IMPORTED_MODULE_3__[/* COLORS */ "a"].white, _utils_styles__WEBPACK_IMPORTED_MODULE_3__[/* COLORS */ "a"].whitesmoke, _utils_constants_ui__WEBPACK_IMPORTED_MODULE_2__[/* DESKTOP */ "e"]]
    }, ["@import url(\"".concat({
      fontUrl: fontUrl
    }, "\");"), "html,body{margin:0;width:100%;height:100%;touch-action:manipulation;color:".concat(theme["color-text--primary"], ";box-sizing:border-box;font-family:").concat(theme["font-family"], ",sans-serif;-webkit-tap-highlight-color:rgba(0,0,0,0);-webkit-font-smoothing:antialiased;}"), "select:hover{background:".concat(_utils_styles__WEBPACK_IMPORTED_MODULE_3__[/* COLORS */ "a"].whitesmoke, ";}"), "select:disabled,input:disabled,.__jsx-style-dynamic-selector{cursor:not-allowed;}", ".cursor-not-allowed{cursor:not-allowed;}", "input:focus,textarea:focus,select:focus,.outline-0:focus{border-color:".concat(_utils_styles__WEBPACK_IMPORTED_MODULE_3__[/* COLORS */ "a"].blueFade, ";border-width:1px;border-style:solid;background:").concat(_utils_styles__WEBPACK_IMPORTED_MODULE_3__[/* COLORS */ "a"].whitesmoke, ";}"), ".layout{width:100%;color:".concat(theme["color-text--primary"], ";}"), "code{font-family:monospace;}", ".color-text--primary{color:".concat(theme["color-text--primary"], ";}"), ".color-text--secondary{color:".concat(theme["color-text--secondary"], ";}"), ".b-primary{border-color:".concat(theme["color-primary"], ";}"), ".color-primary{color:".concat(theme["color-primary"], ";}"), ".feature__enabled--checkmark{color:".concat(theme["bg-primary"], " !important;}"), ".color-error{color:".concat(theme["color-error"], ";}"), ".b--error{border-color:".concat(_utils_styles__WEBPACK_IMPORTED_MODULE_3__[/* COLORS */ "a"].dangerBorder, " !important;}"), ".b--warning{border-color:".concat(_utils_styles__WEBPACK_IMPORTED_MODULE_3__[/* COLORS */ "a"].warning, " !important;}"), ".bg-primary{background-color:".concat(theme["bg-primary"], ";}"), ".bg-white--hover:hover{background-color:".concat(_utils_styles__WEBPACK_IMPORTED_MODULE_3__[/* COLORS */ "a"].whitesmoke, ";}"), ".color-transparent{color:transparent;}", ".currency-select-min-width{min-width:5rem;}", ".min-w3{min-width:4rem;}", ".min-w3-5{min-width:7rem;}", "@media (max-width:".concat(_utils_constants_ui__WEBPACK_IMPORTED_MODULE_2__[/* PHONE */ "j"] + 1, "px){.w-100-s{width:100%;}.dn-imp-s{display:none !important;}}"), ".bg-primary--hover{background-color:".concat(theme["bg-primary--hover"], ";}"), ".bg-primary--fade{background-color:".concat(theme["bg-primary--fade"], ";}"), ".b--primary{border-color:".concat(theme["b-primary"], ";}"), ".ba--primary{border-color:".concat(theme["b-primary"], ";border-width:1px;border-style:solid;}"), ".ba--primary--dotted:hover{border:dotted 2px ".concat(theme["b-primary"], ";margin-left:-2px;margin-right:-2px;}"), ".pb-component:after{pointer-events:none;content:'';display:block;position:absolute;top:0;left:0;width:100%;height:100%;border-radius:inherit;}", ".pb-component:hover:after{cursor:pointer !important;border:dotted 2px ".concat(theme["color-primary"], " !important;}"), ".ba--primary--hover:hover{border-color:".concat(theme["b-primary"], ";border-width:1px;border-style:solid;}"), ".editable__decoration--hover:hover{-webkit-text-decoration:underline !important;text-decoration:underline !important;-webkit-text-decoration-line:underline !important;text-decoration-line:underline !important;-webkit-text-decoration-style:initial !important;text-decoration-style:initial !important;-webkit-text-decoration-color:".concat(theme["color-primary"], ";text-decoration-color:").concat(theme["color-primary"], ";-webkit-text-decoration-thickness:1px;text-decoration-thickness:1px;}"), ".link__underline:hover{-webkit-text-decoration:underline !important;text-decoration:underline !important;-webkit-text-decoration-line:underline !important;text-decoration-line:underline !important;-webkit-text-decoration-style:initial !important;text-decoration-style:initial !important;-webkit-text-decoration-color:".concat(theme["color-text--primary"], ";text-decoration-color:").concat(theme["color-text--primary"], ";-webkit-text-decoration-thickness:1px;text-decoration-thickness:1px;}"), ".dotted__underline:hover{-webkit-text-decoration:underline !important;text-decoration:underline !important;-webkit-text-decoration-line:underline !important;text-decoration-line:underline !important;-webkit-text-decoration-style:dotted !important;text-decoration-style:dotted !important;-webkit-text-decoration-color:".concat(theme["bg-primary--fade"], " !important;text-decoration-color:").concat(theme["bg-primary--fade"], " !important;-webkit-text-decoration-thickness:1px;text-decoration-thickness:1px;color:").concat(theme["bg-primary--fade"], " !important;}"), "p > a{color:".concat(_utils_styles__WEBPACK_IMPORTED_MODULE_3__[/* COLORS */ "a"].blue, ";font-weight:500;-webkit-text-decoration:none;text-decoration:none;}"), ".tdn{-webkit-text-decoration:none !important;text-decoration:none !important;}", ".link__decoration--hover{color:".concat(theme["bg-primary--fade"], ";}"), ".link__decoration--hover:hover,p > a:hover{color:".concat(theme["bg-primary"], " text-decoration:underline !important;-webkit-text-decoration-line:underline !important;text-decoration-line:underline !important;-webkit-text-decoration-style:initial !important;text-decoration-style:initial !important;-webkit-text-decoration-color:initial !important;text-decoration-color:initial !important;}"), ".decoration--hover:hover{-webkit-text-decoration:underline !important;text-decoration:underline !important;-webkit-text-decoration-line:underline !important;text-decoration-line:underline !important;-webkit-text-decoration-style:initial !important;text-decoration-style:initial !important;-webkit-text-decoration-color:initial !important;text-decoration-color:initial !important;}", "button.button--primary,a.button--primary{color:".concat(_utils_styles__WEBPACK_IMPORTED_MODULE_3__[/* COLORS */ "a"].white, ";border-color:").concat(theme["bg-primary--fade"], ";background-color:").concat(theme["bg-primary--fade"], ";}"), "button.button--primary:hover:enabled,a.button--primary:hover:enabled{background-color:".concat(theme["color-primary"], ";border-color:").concat(theme["color-primary"], ";}"), "button.button--primary:focus,a.button--primary:focus{border-color:".concat(theme["b-primary"], ";}"), "button.button--secondary,a.button--secondary{color:".concat(theme["color-primary"], ";border-color:").concat(theme["b-primary"], ";background-color:").concat(_utils_styles__WEBPACK_IMPORTED_MODULE_3__[/* COLORS */ "a"].white, ";}"), "button.button--secondary:hover:enabled,a.button--secondary:hover:enabled{background-color:".concat(_utils_styles__WEBPACK_IMPORTED_MODULE_3__[/* COLORS */ "a"].whitesmoke, ";}"), "button.button--secondary:focus,a.button--secondary:focus{border-color:".concat(theme["b-primary"], ";}"), "button.button--primary:disabled,a.button--primary:disabled,button.button--secondary:disabled,a.button--secondary:disabled,a.disabled-link-button--primary,a.disabled-link-button--secondary{cursor:not-allowed;border-color:inherit;opacity:50%;color:".concat(_utils_styles__WEBPACK_IMPORTED_MODULE_3__[/* COLORS */ "a"].disabled, ";background-color:").concat(_utils_styles__WEBPACK_IMPORTED_MODULE_3__[/* COLORS */ "a"].white, ";border-color:").concat(_utils_styles__WEBPACK_IMPORTED_MODULE_3__[/* COLORS */ "a"].disabled, ";}"), ".token-monospace{font-family:monospace;font-size:12px;}", ".bg-whitesmoke{background-color:".concat(_utils_styles__WEBPACK_IMPORTED_MODULE_3__[/* COLORS */ "a"].whitesmoke, ";}"), ".bg-off-white{background-color:#FBFBFB;}", ".bg-danger-05{background-color:".concat(_utils_styles__WEBPACK_IMPORTED_MODULE_3__[/* COLORS */ "a"].danger05, ";}"), ".bg-warning-05{color:".concat(_utils_styles__WEBPACK_IMPORTED_MODULE_3__[/* COLORS */ "a"].warning05Text, ";background-color:").concat(_utils_styles__WEBPACK_IMPORTED_MODULE_3__[/* COLORS */ "a"].warning05, ";}"), ".bg-success-05{color:#007217;background-color:".concat(_utils_styles__WEBPACK_IMPORTED_MODULE_3__[/* COLORS */ "a"].success05, ";}"), ".bg-gold-05{color:".concat(_utils_styles__WEBPACK_IMPORTED_MODULE_3__[/* COLORS */ "a"].gold05Text, ";background-color:").concat(_utils_styles__WEBPACK_IMPORTED_MODULE_3__[/* COLORS */ "a"].gold05, ";}"), ".auth__footerLink--dot::before{content:\"\u2022\";margin:0px 8px;margin:0px 8px;color:".concat(_utils_styles__WEBPACK_IMPORTED_MODULE_3__[/* COLORS */ "a"].textSecondary, ";}"), "select{background:white;cursor:pointer;}", "input,select,textarea{outline:none;}", "input.PhoneInputInput{border:1px solid rgba(0,0,0,.2);padding:8px;border-radius:4px;border-top-left-radius:0px;border-bottom-left-radius:0px;}", ".PhoneInputCountry{border-top:1px solid rgba(0,0,0,.2);border-bottom:1px solid rgba(0,0,0,.2);border-left:1px solid rgba(0,0,0,.2);padding:8px;border-radius:4px;margin-right:0;border-top-right-radius:0px;border-bottom-right-radius:0px;}", ".outline-0{outline:none;}", ".brl2--top{border-top-left-radius:.25rem;}", ".mw-app{max-width:".concat(_utils_constants_ui__WEBPACK_IMPORTED_MODULE_2__[/* MAX_WIDTH */ "f"], "px;}"), ".word-break{word-break:break-word;}", ".word-break-all{word-break:break-all;}", ".cursor-grab{cursor:-webkit-grab;cursor:-moz-grab;cursor:grab;}", ".cursor-auto{cursor:auto;}", ".cursor-move{cursor:move;}", ".cursor-not-allowed{cursor:not-allowed;}", ".pointer-default{cursor:default;}", "input:not([type=\"checkbox\"]):not([type=\"radio\"]){-webkit-appearance:none;}", "input[type=\"search\"]::-webkit-search-decoration,input[type=\"search\"]::-webkit-search-cancel-button,input[type=\"search\"]::-webkit-search-results-button,input[type=\"search\"]::-webkit-search-results-decoration{-webkit-appearance:none;}", "::-webkit-scrollbar{width:0;background:transparent;}", ".bg-content--secondary{background-color:".concat(_utils_styles__WEBPACK_IMPORTED_MODULE_3__[/* COLORS */ "a"].content.secondary, ";}"), ".bg-content--hover:hover{background-color:".concat(_utils_styles__WEBPACK_IMPORTED_MODULE_3__[/* COLORS */ "a"].content.hover, ";}"), ".bh--inset{box-shadow:rgba(0,0,0,0.07) -1px 0px inset;}", ".bh--inset--hover:hover{box-shadow:rgba(0,0,0,0.07) -1px 0px inset;}", ".b-inner--primary{box-shadow:0px 0px 0px 1px ".concat(theme["color-primary"], " inset;}"), ".b-inner--primary-fade{box-shadow:0px 0px 0px 1px ".concat(_utils_styles__WEBPACK_IMPORTED_MODULE_3__[/* COLORS */ "a"].blueFade, " inset;}"), ".sticky{position:-webkit-sticky;position:sticky;}", "@media (min-width:".concat(_utils_constants_ui__WEBPACK_IMPORTED_MODULE_2__[/* DESKTOP */ "e"], "px){.sticky-l{position:-webkit-sticky;position:sticky;}}"), ".move{cursor:-webkit-move;cursor:move;}", ".user-select-n{-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;}", ".hidden{visibility:hidden;}", "textarea{-webkit-appearance:none;}", ".f2-5{font-size:1.875rem;}", ".f4-5{font-size:1.125rem;}", ".z-6{z-index:6;}", ".z-7{z-index:7;}", "input:disabled{-webkit-text-fill-color:rgba(51,51,51,0.8);-webkit-opacity:1;background:white;}", "textarea:disabled{-webkit-text-fill-color:rgba(51,51,51,0.8);-webkit-opacity:1;background:white;}", ".field__label{font-size:14px;}", "@media (min-width:".concat(_utils_constants_ui__WEBPACK_IMPORTED_MODULE_2__[/* PHONE */ "j"] + 1, "px){.form__content--paddingTop-ns{padding-top:146px;padding-bottom:146px;}}"), "#__next{height:100%;}", ".mw-0{min-width:0;}", ".shadow-0{-webkit-box-shadow:inset 0px 4px 8px -3px rgba(17,17,17,0.06);-moz-box-shadow:0 3px 6px 0 rgba(0,0,0,0.06);box-shadow:0 3px 6px 0 rgba(0,0,0,0.06);}", ".hairline-2{border-color:rgba(0,0,0,0.2);border-width:1px;}", ".hairline-0{border-color:rgba(0,0,0,0.025);border-width:1px;}", ".brn{border-right:none;}", "@media (min-width:".concat(_utils_constants_ui__WEBPACK_IMPORTED_MODULE_2__[/* PHONE */ "j"] + 1, "px){.brn-ns{border-right:none;}}"), "@media (min-width:".concat(_utils_constants_ui__WEBPACK_IMPORTED_MODULE_2__[/* PHONE */ "j"] + 1, "px){.bg-off-white-ns{background-color:#FDFDFD;}}"), "@media (min-width:".concat(_utils_constants_ui__WEBPACK_IMPORTED_MODULE_2__[/* PHONE */ "j"] + 1, "px){.split__container-ns{box-shadow:15px 0 30px 0 rgb(0 0 0 / 18%);}}"), ".w2-5{width:3rem;}", ".h5-5{height:24rem;}", ".hairline-1{border-color:rgba(0,0,0,0.08);border-width:1px;}", ".hairline-1-dashed-primary{border-color:".concat(_utils_styles__WEBPACK_IMPORTED_MODULE_3__[/* COLORS */ "a"].blue, ";border-style:dashed;border-width:1px;}"), "@media (max-width:".concat(_utils_constants_ui__WEBPACK_IMPORTED_MODULE_2__[/* PHONE */ "j"], "px){.bt-hairline-1-s{border-top:1px solid rgba(0,0,0,0.08);}.hairline-1-s{border-color:rgba(0,0,0,0.08);border-style:solid;border-width:1px;}.shadow-0-s{-webkit-box-shadow:inset 0px 4px 8px -3px rgba(17,17,17,0.06);-moz-box-shadow:0 3px 6px 0 rgba(0,0,0,0.06);box-shadow:0 3px 6px 0 rgba(0,0,0,0.06);}}"), "@media (min-width:".concat(_utils_constants_ui__WEBPACK_IMPORTED_MODULE_2__[/* PHONE */ "j"] + 1, "px){.hairline-1-ns{border-color:rgba(0,0,0,0.08);border-style:solid;border-width:1px;}.shadow-0-ns{-webkit-box-shadow:inset 0px 4px 8px -3px rgba(17,17,17,0.06);-moz-box-shadow:0 3px 6px 0 rgba(0,0,0,0.06);box-shadow:0 3px 6px 0 rgba(0,0,0,0.06);}.bg-transparent-ns{background-color:transparent;}.bln-ns{border-left:0;}.min-vh-100-ns{min-height:100vh;}}"), "@media (min-width:".concat(_utils_constants_ui__WEBPACK_IMPORTED_MODULE_2__[/* DESKTOP */ "e"], "px){.bg-white-l{background-color:").concat(_utils_styles__WEBPACK_IMPORTED_MODULE_3__[/* COLORS */ "a"].white, ";}}"), ".b--whitesmoke-hover{border-color:white;}", ".b--whitesmoke-hover:hover{border-color:".concat(_utils_styles__WEBPACK_IMPORTED_MODULE_3__[/* COLORS */ "a"].whitesmoke, ";}"), ".ta-man{touch-action:manipulation;}", "@media (min-width:".concat(_utils_constants_ui__WEBPACK_IMPORTED_MODULE_2__[/* DESKTOP */ "e"], "px){.f3-5-l{font-size:30px;}}"), ".flex-shrink-0{-webkit-flex-shrink:0;-ms-flex-negative:0;flex-shrink:0;}", ".container__float{-webkit-box-shadow:0 3px 6px 0 rgba(0,0,0,0.08);-moz-box-shadow:0 3px 6px 0 rgba(0,0,0,0.08);box-shadow:0 3px 6px 0 rgba(0,0,0,0.08);}", ".b--transparent{border-color:transparent;}", "iframe{width:100%;}", ".CalendarDay__selected,.CalendarDay__selected:active,.CalendarDay__selected:hover{background:#4990e2;border-width:1px;border-style:solid;border-color:#4990e2;color:#fff;}", ".react-toggle-thumb{box-shadow:none !important;}", ".DateInput_input__focused{outline:0;background:#fff;border-top:0;border-left:0;border-right:0;bbottom:2px: border-style:solid;border-color:#4990e2;}", ".bg--black-025{background-color:rgba(0,0,0,0.025);}", ".brtl-0{border-top-left-radius:0;}", ".brtr-0{border-top-right-radius:0;}", ".brbl-0{bbottom-left-radius:0;}", ".brbr-0{bbottom-right-radius:0;}", ".brtl-2{border-top-left-radius:0.25rem;}", ".brtr-2{border-top-right-radius:0.25rem;}", ".brbl-2{bbottom-left-radius:0.25rem;}", ".brbr-2{bbottom-right-radius:0.25rem;}", ".cursor__move:hover{cursor:move;}", ".grecaptcha-badge{display:none;}", ".app__action--form{max-width:400px;}", "@media (max-width:30em){.slide__container{height:16rem;}}", "@media (min-width:30em) and (max-width:60em){.slide__container{height:16rem;}}", "@media (min-width:60em){.slide__container{height:19rem;}}", "@media (max-width:30em){.useCase__container{height:2.25rem;}}", "@media (min-width:30em) and (max-width:60em){.useCase__container{height:2.25rem;}}", "@media (min-width:60em){.useCase__container{height:3.125rem;}}", "@media (max-width:30em){.service__container{height:2.25rem;}}", "@media (min-width:30em) and (max-width:60em){.service__container{height:2.125rem;}}", "@media (min-width:60em){.service__container{height:2.125rem;}}", ".paymentMethod__container{height:2rem;width:3.75rem;}", "@media (max-width:30em){.socialService__container{height:2.25rem;}}", "@media (min-width:30em) and (max-width:60em){.socialService__container{height:3rem;}}", "@media (min-width:60em){.socialService__container{height:3rem;}}", ".slide__image::after,.image__cover--after::after{content:\"\";position:absolute;pointer-events:none;top:0;left:0;width:100%;height:100%;background-color:transparent;background-size:contain;background-position:bottom;background-repeat:no-repeat;}", "path.recharts-tooltip-cursor{fill:whitesmoke;}", ".color-usa-red{color:#D22738;}", ".b--usa-red{border-color:#D22738;}", ".color-usa-blue{color:#05408E;}"]),
    className: styled_jsx_style__WEBPACK_IMPORTED_MODULE_1___default.a.dynamic([["2865940685", [{
      fontUrl: fontUrl
    }, theme["color-text--primary"], theme["font-family"], _utils_styles__WEBPACK_IMPORTED_MODULE_3__[/* COLORS */ "a"].whitesmoke, _utils_styles__WEBPACK_IMPORTED_MODULE_3__[/* COLORS */ "a"].blueFade, _utils_styles__WEBPACK_IMPORTED_MODULE_3__[/* COLORS */ "a"].whitesmoke, theme["color-text--primary"], theme["color-text--primary"], theme["color-text--secondary"], theme["color-primary"], theme["color-primary"], theme["bg-primary"], theme["color-error"], _utils_styles__WEBPACK_IMPORTED_MODULE_3__[/* COLORS */ "a"].dangerBorder, _utils_styles__WEBPACK_IMPORTED_MODULE_3__[/* COLORS */ "a"].warning, theme["bg-primary"], _utils_styles__WEBPACK_IMPORTED_MODULE_3__[/* COLORS */ "a"].whitesmoke, _utils_constants_ui__WEBPACK_IMPORTED_MODULE_2__[/* PHONE */ "j"] + 1, theme["bg-primary--hover"], theme["bg-primary--fade"], theme["b-primary"], theme["b-primary"], theme["b-primary"], theme["color-primary"], theme["b-primary"], theme["color-primary"], theme["color-text--primary"], theme["bg-primary--fade"], theme["bg-primary--fade"], _utils_styles__WEBPACK_IMPORTED_MODULE_3__[/* COLORS */ "a"].blue, theme["bg-primary--fade"], theme["bg-primary"], _utils_styles__WEBPACK_IMPORTED_MODULE_3__[/* COLORS */ "a"].white, theme["bg-primary--fade"], theme["bg-primary--fade"], theme["color-primary"], theme["color-primary"], theme["b-primary"], theme["color-primary"], theme["b-primary"], _utils_styles__WEBPACK_IMPORTED_MODULE_3__[/* COLORS */ "a"].white, _utils_styles__WEBPACK_IMPORTED_MODULE_3__[/* COLORS */ "a"].whitesmoke, theme["b-primary"], _utils_styles__WEBPACK_IMPORTED_MODULE_3__[/* COLORS */ "a"].disabled, _utils_styles__WEBPACK_IMPORTED_MODULE_3__[/* COLORS */ "a"].white, _utils_styles__WEBPACK_IMPORTED_MODULE_3__[/* COLORS */ "a"].disabled, _utils_styles__WEBPACK_IMPORTED_MODULE_3__[/* COLORS */ "a"].whitesmoke, _utils_styles__WEBPACK_IMPORTED_MODULE_3__[/* COLORS */ "a"].danger05, _utils_styles__WEBPACK_IMPORTED_MODULE_3__[/* COLORS */ "a"].warning05Text, _utils_styles__WEBPACK_IMPORTED_MODULE_3__[/* COLORS */ "a"].warning05, _utils_styles__WEBPACK_IMPORTED_MODULE_3__[/* COLORS */ "a"].success05, _utils_styles__WEBPACK_IMPORTED_MODULE_3__[/* COLORS */ "a"].gold05Text, _utils_styles__WEBPACK_IMPORTED_MODULE_3__[/* COLORS */ "a"].gold05, _utils_styles__WEBPACK_IMPORTED_MODULE_3__[/* COLORS */ "a"].textSecondary, _utils_constants_ui__WEBPACK_IMPORTED_MODULE_2__[/* MAX_WIDTH */ "f"], _utils_styles__WEBPACK_IMPORTED_MODULE_3__[/* COLORS */ "a"].content.secondary, _utils_styles__WEBPACK_IMPORTED_MODULE_3__[/* COLORS */ "a"].content.hover, theme["color-primary"], _utils_styles__WEBPACK_IMPORTED_MODULE_3__[/* COLORS */ "a"].blueFade, _utils_constants_ui__WEBPACK_IMPORTED_MODULE_2__[/* DESKTOP */ "e"], _utils_constants_ui__WEBPACK_IMPORTED_MODULE_2__[/* PHONE */ "j"] + 1, _utils_constants_ui__WEBPACK_IMPORTED_MODULE_2__[/* PHONE */ "j"] + 1, _utils_constants_ui__WEBPACK_IMPORTED_MODULE_2__[/* PHONE */ "j"] + 1, _utils_constants_ui__WEBPACK_IMPORTED_MODULE_2__[/* PHONE */ "j"] + 1, _utils_styles__WEBPACK_IMPORTED_MODULE_3__[/* COLORS */ "a"].blue, _utils_constants_ui__WEBPACK_IMPORTED_MODULE_2__[/* PHONE */ "j"], _utils_constants_ui__WEBPACK_IMPORTED_MODULE_2__[/* PHONE */ "j"] + 1, _utils_constants_ui__WEBPACK_IMPORTED_MODULE_2__[/* DESKTOP */ "e"], _utils_styles__WEBPACK_IMPORTED_MODULE_3__[/* COLORS */ "a"].white, _utils_styles__WEBPACK_IMPORTED_MODULE_3__[/* COLORS */ "a"].whitesmoke, _utils_constants_ui__WEBPACK_IMPORTED_MODULE_2__[/* DESKTOP */ "e"]]]])
  };
};

/***/ }),

/***/ 0:
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__("GcxT");
module.exports = __webpack_require__("nOHt");


/***/ }),

/***/ "2bdC":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return registerErrorInstrumentation; });
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("6hSO");
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("8LbN");
/* harmony import */ var _spanstatus__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("bju/");
/* harmony import */ var _utils__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("FGHR");



/**
 * Configures global error listeners
 */
function registerErrorInstrumentation() {
    Object(_sentry_utils__WEBPACK_IMPORTED_MODULE_0__[/* addInstrumentationHandler */ "a"])({
        callback: errorCallback,
        type: 'error',
    });
    Object(_sentry_utils__WEBPACK_IMPORTED_MODULE_0__[/* addInstrumentationHandler */ "a"])({
        callback: errorCallback,
        type: 'unhandledrejection',
    });
}
/**
 * If an error or unhandled promise occurs, we mark the active transaction as failed
 */
function errorCallback() {
    var activeTransaction = Object(_utils__WEBPACK_IMPORTED_MODULE_3__[/* getActiveTransaction */ "b"])();
    if (activeTransaction) {
        _sentry_utils__WEBPACK_IMPORTED_MODULE_1__[/* logger */ "a"].log("[Tracing] Transaction: " + _spanstatus__WEBPACK_IMPORTED_MODULE_2__[/* SpanStatus */ "a"].InternalError + " -> Global error occured");
        activeTransaction.setStatus(_spanstatus__WEBPACK_IMPORTED_MODULE_2__[/* SpanStatus */ "a"].InternalError);
    }
}
//# sourceMappingURL=errors.js.map

/***/ }),

/***/ "5Buo":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "Cpvd":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return startIdleTransaction; });
/* unused harmony export _addTracingExtensions */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return addExtensionMethods; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("mrSG");
/* harmony import */ var _sentry_hub__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("lW6c");
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("8LbN");
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("+A1k");
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("9AQC");
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("9/Zf");
/* harmony import */ var _errors__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("2bdC");
/* harmony import */ var _idletransaction__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__("MBYv");
/* harmony import */ var _transaction__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__("EldZ");
/* harmony import */ var _utils__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__("FGHR");







/** Returns all trace headers that are currently on the top scope. */
function traceHeaders() {
    var scope = this.getScope();
    if (scope) {
        var span = scope.getSpan();
        if (span) {
            return {
                'sentry-trace': span.toTraceparent(),
            };
        }
    }
    return {};
}
/**
 * Implements sampling inheritance and falls back to user-provided static rate if no parent decision is available.
 *
 * @param parentSampled: The parent transaction's sampling decision, if any.
 * @param givenRate: The rate to use if no parental decision is available.
 *
 * @returns The parent's sampling decision (if one exists), or the provided static rate
 */
function _inheritOrUseGivenRate(parentSampled, givenRate) {
    return parentSampled !== undefined ? parentSampled : givenRate;
}
/**
 * Makes a sampling decision for the given transaction and stores it on the transaction.
 *
 * Called every time a transaction is created. Only transactions which emerge with a `sampled` value of `true` will be
 * sent to Sentry.
 *
 * @param hub: The hub off of which to read config options
 * @param transaction: The transaction needing a sampling decision
 * @param samplingContext: Default and user-provided data which may be used to help make the decision
 *
 * @returns The given transaction with its `sampled` value set
 */
function sample(hub, transaction, samplingContext) {
    var _a;
    var client = hub.getClient();
    var options = (client && client.getOptions()) || {};
    // nothing to do if there's no client or if tracing is disabled
    if (!client || !Object(_utils__WEBPACK_IMPORTED_MODULE_9__[/* hasTracingEnabled */ "c"])(options)) {
        transaction.sampled = false;
        return transaction;
    }
    // we would have bailed already if neither `tracesSampler` nor `tracesSampleRate` were defined, so one of these should
    // work; prefer the hook if so
    var sampleRate = typeof options.tracesSampler === 'function'
        ? options.tracesSampler(samplingContext)
        : _inheritOrUseGivenRate(samplingContext.parentSampled, options.tracesSampleRate);
    // Since this is coming from the user (or from a function provided by the user), who knows what we might get. (The
    // only valid values are booleans or numbers between 0 and 1.)
    if (!isValidSampleRate(sampleRate)) {
        _sentry_utils__WEBPACK_IMPORTED_MODULE_2__[/* logger */ "a"].warn("[Tracing] Discarding transaction because of invalid sample rate.");
        transaction.sampled = false;
        return transaction;
    }
    // if the function returned 0 (or false), or if `tracesSampleRate` is 0, it's a sign the transaction should be dropped
    if (!sampleRate) {
        _sentry_utils__WEBPACK_IMPORTED_MODULE_2__[/* logger */ "a"].log("[Tracing] Discarding transaction because " + (typeof options.tracesSampler === 'function'
            ? 'tracesSampler returned 0 or false'
            : 'tracesSampleRate is set to 0'));
        transaction.sampled = false;
        return transaction;
    }
    // Now we roll the dice. Math.random is inclusive of 0, but not of 1, so strict < is safe here. In case sampleRate is
    // a boolean, the < comparison will cause it to be automatically cast to 1 if it's true and 0 if it's false.
    transaction.sampled = Math.random() < sampleRate;
    // if we're not going to keep it, we're done
    if (!transaction.sampled) {
        _sentry_utils__WEBPACK_IMPORTED_MODULE_2__[/* logger */ "a"].log("[Tracing] Discarding transaction because it's not included in the random sample (sampling rate = " + Number(sampleRate) + ")");
        return transaction;
    }
    // at this point we know we're keeping the transaction, whether because of an inherited decision or because it got
    // lucky with the dice roll
    transaction.initSpanRecorder((_a = options._experiments) === null || _a === void 0 ? void 0 : _a.maxSpans);
    _sentry_utils__WEBPACK_IMPORTED_MODULE_2__[/* logger */ "a"].log("[Tracing] starting " + transaction.op + " transaction - " + transaction.name);
    return transaction;
}
/**
 * Gets the correct context to pass to the tracesSampler, based on the environment (i.e., which SDK is being used)
 *
 * @returns The default sample context
 */
function getDefaultSamplingContext(transactionContext) {
    // promote parent sampling decision (if any) for easy access
    var parentSampled = transactionContext.parentSampled;
    var defaultSamplingContext = { transactionContext: transactionContext, parentSampled: parentSampled };
    if (Object(_sentry_utils__WEBPACK_IMPORTED_MODULE_3__[/* isNodeEnv */ "c"])()) {
        var domain = Object(_sentry_hub__WEBPACK_IMPORTED_MODULE_1__[/* getActiveDomain */ "b"])();
        if (domain) {
            // for all node servers that we currently support, we store the incoming request object (which is an instance of
            // http.IncomingMessage) on the domain
            // the domain members are stored as an array, so our only way to find the request is to iterate through the array
            // and compare types
            var nodeHttpModule = Object(_sentry_utils__WEBPACK_IMPORTED_MODULE_3__[/* dynamicRequire */ "a"])(module, 'http');
            // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
            var requestType_1 = nodeHttpModule.IncomingMessage;
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            var request = domain.members.find(function (member) { return Object(_sentry_utils__WEBPACK_IMPORTED_MODULE_4__[/* isInstanceOf */ "g"])(member, requestType_1); });
            if (request) {
                defaultSamplingContext.request = Object(_sentry_utils__WEBPACK_IMPORTED_MODULE_3__[/* extractNodeRequestData */ "b"])(request);
            }
        }
    }
    // we must be in browser-js (or some derivative thereof)
    else {
        // we use `getGlobalObject()` rather than `window` since service workers also have a `location` property on `self`
        var globalObject = Object(_sentry_utils__WEBPACK_IMPORTED_MODULE_5__[/* getGlobalObject */ "e"])();
        if ('location' in globalObject) {
            // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access, @typescript-eslint/no-explicit-any
            defaultSamplingContext.location = Object(tslib__WEBPACK_IMPORTED_MODULE_0__[/* __assign */ "a"])({}, globalObject.location);
        }
    }
    return defaultSamplingContext;
}
/**
 * Checks the given sample rate to make sure it is valid type and value (a boolean, or a number between 0 and 1).
 */
function isValidSampleRate(rate) {
    // we need to check NaN explicitly because it's of type 'number' and therefore wouldn't get caught by this typecheck
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    if (isNaN(rate) || !(typeof rate === 'number' || typeof rate === 'boolean')) {
        _sentry_utils__WEBPACK_IMPORTED_MODULE_2__[/* logger */ "a"].warn("[Tracing] Given sample rate is invalid. Sample rate must be a boolean or a number between 0 and 1. Got " + JSON.stringify(rate) + " of type " + JSON.stringify(typeof rate) + ".");
        return false;
    }
    // in case sampleRate is a boolean, it will get automatically cast to 1 if it's true and 0 if it's false
    if (rate < 0 || rate > 1) {
        _sentry_utils__WEBPACK_IMPORTED_MODULE_2__[/* logger */ "a"].warn("[Tracing] Given sample rate is invalid. Sample rate must be between 0 and 1. Got " + rate + ".");
        return false;
    }
    return true;
}
/**
 * Creates a new transaction and adds a sampling decision if it doesn't yet have one.
 *
 * The Hub.startTransaction method delegates to this method to do its work, passing the Hub instance in as `this`.
 * Exists as a separate function so that it can be injected into the class as an "extension method."
 *
 * @param this: The Hub starting the transaction
 * @param transactionContext: Data used to configure the transaction
 * @param CustomSamplingContext: Optional data to be provided to the `tracesSampler` function (if any)
 *
 * @returns The new transaction
 *
 * @see {@link Hub.startTransaction}
 */
function _startTransaction(transactionContext, customSamplingContext) {
    var transaction = new _transaction__WEBPACK_IMPORTED_MODULE_8__[/* Transaction */ "a"](transactionContext, this);
    return sample(this, transaction, Object(tslib__WEBPACK_IMPORTED_MODULE_0__[/* __assign */ "a"])(Object(tslib__WEBPACK_IMPORTED_MODULE_0__[/* __assign */ "a"])({}, getDefaultSamplingContext(transactionContext)), customSamplingContext));
}
/**
 * Create new idle transaction.
 */
function startIdleTransaction(hub, transactionContext, idleTimeout, onScope) {
    var transaction = new _idletransaction__WEBPACK_IMPORTED_MODULE_7__[/* IdleTransaction */ "b"](transactionContext, hub, idleTimeout, onScope);
    return sample(hub, transaction, getDefaultSamplingContext(transactionContext));
}
/**
 * @private
 */
function _addTracingExtensions() {
    var carrier = Object(_sentry_hub__WEBPACK_IMPORTED_MODULE_1__[/* getMainCarrier */ "e"])();
    if (carrier.__SENTRY__) {
        carrier.__SENTRY__.extensions = carrier.__SENTRY__.extensions || {};
        if (!carrier.__SENTRY__.extensions.startTransaction) {
            carrier.__SENTRY__.extensions.startTransaction = _startTransaction;
        }
        if (!carrier.__SENTRY__.extensions.traceHeaders) {
            carrier.__SENTRY__.extensions.traceHeaders = traceHeaders;
        }
    }
}
/**
 * This patches the global object and injects the Tracing extensions methods
 */
function addExtensionMethods() {
    _addTracingExtensions();
    // If an error happens globally, we should make sure transaction status is set to error.
    Object(_errors__WEBPACK_IMPORTED_MODULE_6__[/* registerErrorInstrumentation */ "a"])();
}
//# sourceMappingURL=hubextensions.js.map
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__("3UD+")(module)))

/***/ }),

/***/ "E79Q":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getBlocksStyles; });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("q1tI");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var styled_jsx_style__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("MX0m");
/* harmony import */ var styled_jsx_style__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(styled_jsx_style__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _utils_styles__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("oCA+");

var __jsx = react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement;


var getBlocksStyles = function getBlocksStyles(theme) {
  return {
    styles: __jsx(styled_jsx_style__WEBPACK_IMPORTED_MODULE_1___default.a, {
      id: "3686357239",
      dynamic: [theme["color-text--secondary"], _utils_styles__WEBPACK_IMPORTED_MODULE_2__[/* COLORS */ "a"].whitesmoke, theme["color-text--primary"], theme["color-text--primary"], theme["color-text--secondary"], theme["color-primary"], theme["bg-primary"], theme["color-error"], theme["bg-primary"], theme["bg-primary--hover"], theme["bg-primary--fade"], theme["b-primary"], theme["b-primary"], theme["color-primary"], theme["color-primary"], theme["color-primary"], theme["color-primary"], theme["color-highlight"], _utils_styles__WEBPACK_IMPORTED_MODULE_2__[/* COLORS */ "a"].white, theme["bg-primary--fade"], theme["bg-primary--fade"], theme["color-primary"], theme["color-primary"], theme["b-primary"], theme["color-primary"], theme["b-primary"], _utils_styles__WEBPACK_IMPORTED_MODULE_2__[/* COLORS */ "a"].white, _utils_styles__WEBPACK_IMPORTED_MODULE_2__[/* COLORS */ "a"].whitesmoke, theme["b-primary"], _utils_styles__WEBPACK_IMPORTED_MODULE_2__[/* COLORS */ "a"].disabled, _utils_styles__WEBPACK_IMPORTED_MODULE_2__[/* COLORS */ "a"].white, _utils_styles__WEBPACK_IMPORTED_MODULE_2__[/* COLORS */ "a"].disabled]
    }, ["input.BLOCKS__page__element:focus,textarea.BLOCKS__page__element:focus,select.BLOCKS__page__element:focus,.outline-0.BLOCKS__page__element:focus{border-color:".concat(theme["color-text--secondary"], ";border-width:1px;border-style:solid;background:").concat(_utils_styles__WEBPACK_IMPORTED_MODULE_2__[/* COLORS */ "a"].whitesmoke, ";}"), ".BLOCKS__layout{width:100%;color:".concat(theme["color-text--primary"], ";}"), ".BLOCKS__color-text--primary{color:".concat(theme["color-text--primary"], ";}"), ".BLOCKS__color-text--secondary{color:".concat(theme["color-text--secondary"], ";}"), ".BLOCKS__color-primary{color:".concat(theme["color-primary"], ";}"), ".BLOCKS__feature__enabled--checkmark{color:".concat(theme["bg-primary"], ";}"), ".BLOCKS__color-error{color:".concat(theme["color-error"], ";}"), ".BLOCKS__bg-primary{background-color:".concat(theme["bg-primary"], ";}"), ".BLOCKS__bg-primary--hover{background-color:".concat(theme["bg-primary--hover"], ";}"), ".BLOCKS__bg-primary--fade{background-color:".concat(theme["bg-primary--fade"], ";}"), ".BLOCKS__ba--primary{border-color:".concat(theme["b-primary"], ";border-width:1px;border-style:solid;}"), ".BLOCKS__ba--primary--dotted:hover:after{border:dotted 2px ".concat(theme["b-primary"], ";}"), ".BLOCKS__pb-component:after{pointer-events:none;content:\"\";display:block;position:absolute;top:0;left:0;width:100%;height:100%;border-radius:inherit;}", ".BLOCKS__pb-component:hover:after{cursor:pointer !important;border:dotted 2px ".concat(theme["color-primary"], " !important;}"), ".BLOCKS__editable__decoration--hover:hover:enabled{-webkit-text-decoration:underline;text-decoration:underline;-webkit-text-decoration-line:underline;text-decoration-line:underline;-webkit-text-decoration-style:initial;text-decoration-style:initial;-webkit-text-decoration-color:".concat(theme["color-primary"], ";text-decoration-color:").concat(theme["color-primary"], ";-webkit-text-decoration-thickness:1px;text-decoration-thickness:1px;}"), ".BLOCKS__link__decoration--hover{color:".concat(theme["color-primary"], ";}"), ".BLOCKS__link__decoration--hover:hover:enabled{color:".concat(theme["color-primary"], ";-webkit-text-decoration:underline;text-decoration:underline;-webkit-text-decoration-line:underline;text-decoration-line:underline;-webkit-text-decoration-style:initial;text-decoration-style:initial;-webkit-text-decoration-color:initial;text-decoration-color:initial;}"), ".BLOCKS__highlight{background-color:".concat(theme["color-highlight"], ";}"), "button.BLOCKS__button--primary,a.BLOCKS__button--primary{color:".concat(_utils_styles__WEBPACK_IMPORTED_MODULE_2__[/* COLORS */ "a"].white, ";border-color:").concat(theme["bg-primary--fade"], ";background-color:").concat(theme["bg-primary--fade"], ";}"), "button.BLOCKS__button--primary:hover:enabled,a.BLOCKS__button--primary:hover:enabled{background-color:".concat(theme["color-primary"], ";border-color:").concat(theme["color-primary"], ";}"), "button.BLOCKS__button--primary:focus,a.BLOCKS__button--primary:focus{border-color:".concat(theme["b-primary"], ";}"), "button.BLOCKS__button--primary:disabled,a.BLOCKS__button--primary:disabled{cursor:not-allowed;border-color:inherit;}", "button.BLOCKS__button--secondary,a.BLOCKS__button--secondary{color:".concat(theme["color-primary"], ";border-color:").concat(theme["b-primary"], ";background-color:").concat(_utils_styles__WEBPACK_IMPORTED_MODULE_2__[/* COLORS */ "a"].white, ";}"), "button.BLOCKS__button--secondary:hover:enabled,a.BLOCKS__button--secondary:hover:enabled{background-color:".concat(_utils_styles__WEBPACK_IMPORTED_MODULE_2__[/* COLORS */ "a"].whitesmoke, ";}"), "button.BLOCKS__button--secondary:focus,a.BLOCKS__button--secondary:focus{border-color:".concat(theme["b-primary"], ";}"), "button.BLOCKS__button--secondary:disabled,a.BLOCKS__button--secondary:disabled{cursor:not-allowed;border-color:inherit;}", "button.BLOCKS__button--primary:disabled,a.BLOCKS__button--primary:disabled,button.BLOCKS__button--secondary:disabled,a.BLOCKS__button--secondary:disabled{cursor:not-allowed;border-color:inherit;opacity:50%;color:".concat(_utils_styles__WEBPACK_IMPORTED_MODULE_2__[/* COLORS */ "a"].disabled, ";background-color:").concat(_utils_styles__WEBPACK_IMPORTED_MODULE_2__[/* COLORS */ "a"].white, ";border-color:").concat(_utils_styles__WEBPACK_IMPORTED_MODULE_2__[/* COLORS */ "a"].disabled, ";}")]),
    className: styled_jsx_style__WEBPACK_IMPORTED_MODULE_1___default.a.dynamic([["3686357239", [theme["color-text--secondary"], _utils_styles__WEBPACK_IMPORTED_MODULE_2__[/* COLORS */ "a"].whitesmoke, theme["color-text--primary"], theme["color-text--primary"], theme["color-text--secondary"], theme["color-primary"], theme["bg-primary"], theme["color-error"], theme["bg-primary"], theme["bg-primary--hover"], theme["bg-primary--fade"], theme["b-primary"], theme["b-primary"], theme["color-primary"], theme["color-primary"], theme["color-primary"], theme["color-primary"], theme["color-highlight"], _utils_styles__WEBPACK_IMPORTED_MODULE_2__[/* COLORS */ "a"].white, theme["bg-primary--fade"], theme["bg-primary--fade"], theme["color-primary"], theme["color-primary"], theme["b-primary"], theme["color-primary"], theme["b-primary"], _utils_styles__WEBPACK_IMPORTED_MODULE_2__[/* COLORS */ "a"].white, _utils_styles__WEBPACK_IMPORTED_MODULE_2__[/* COLORS */ "a"].whitesmoke, theme["b-primary"], _utils_styles__WEBPACK_IMPORTED_MODULE_2__[/* COLORS */ "a"].disabled, _utils_styles__WEBPACK_IMPORTED_MODULE_2__[/* COLORS */ "a"].white, _utils_styles__WEBPACK_IMPORTED_MODULE_2__[/* COLORS */ "a"].disabled]]])
  };
};

/***/ }),

/***/ "EldZ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Transaction; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("mrSG");
/* harmony import */ var _sentry_hub__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("lW6c");
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("9AQC");
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("8LbN");
/* harmony import */ var _span__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("SYqL");




/** JSDoc */
var Transaction = /** @class */ (function (_super) {
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__[/* __extends */ "b"])(Transaction, _super);
    /**
     * This constructor should never be called manually. Those instrumenting tracing should use
     * `Sentry.startTransaction()`, and internal methods should use `hub.startTransaction()`.
     * @internal
     * @hideconstructor
     * @hidden
     */
    function Transaction(transactionContext, hub) {
        var _this = _super.call(this, transactionContext) || this;
        /**
         * The reference to the current hub.
         */
        _this._hub = Object(_sentry_hub__WEBPACK_IMPORTED_MODULE_1__[/* getCurrentHub */ "c"])();
        if (Object(_sentry_utils__WEBPACK_IMPORTED_MODULE_2__[/* isInstanceOf */ "g"])(hub, _sentry_hub__WEBPACK_IMPORTED_MODULE_1__[/* Hub */ "a"])) {
            _this._hub = hub;
        }
        if (transactionContext.name) {
            _this.name = transactionContext.name;
        }
        _this._trimEnd = transactionContext.trimEnd;
        return _this;
    }
    /**
     * JSDoc
     */
    Transaction.prototype.setName = function (name) {
        this.name = name;
    };
    /**
     * Attaches SpanRecorder to the span itself
     * @param maxlen maximum number of spans that can be recorded
     */
    Transaction.prototype.initSpanRecorder = function (maxlen) {
        if (maxlen === void 0) { maxlen = 1000; }
        if (!this.spanRecorder) {
            this.spanRecorder = new _span__WEBPACK_IMPORTED_MODULE_4__[/* SpanRecorder */ "b"](maxlen);
        }
        this.spanRecorder.add(this);
    };
    /**
     * @inheritDoc
     */
    Transaction.prototype.finish = function (endTimestamp) {
        var _this = this;
        // This transaction is already finished, so we should not flush it again.
        if (this.endTimestamp !== undefined) {
            return undefined;
        }
        if (!this.name) {
            _sentry_utils__WEBPACK_IMPORTED_MODULE_3__[/* logger */ "a"].warn('Transaction has no name, falling back to `<unlabeled transaction>`.');
            this.name = '<unlabeled transaction>';
        }
        // just sets the end timestamp
        _super.prototype.finish.call(this, endTimestamp);
        if (this.sampled !== true) {
            // At this point if `sampled !== true` we want to discard the transaction.
            _sentry_utils__WEBPACK_IMPORTED_MODULE_3__[/* logger */ "a"].log('[Tracing] Discarding transaction because its trace was not chosen to be sampled.');
            return undefined;
        }
        var finishedSpans = this.spanRecorder ? this.spanRecorder.spans.filter(function (s) { return s !== _this && s.endTimestamp; }) : [];
        if (this._trimEnd && finishedSpans.length > 0) {
            this.endTimestamp = finishedSpans.reduce(function (prev, current) {
                if (prev.endTimestamp && current.endTimestamp) {
                    return prev.endTimestamp > current.endTimestamp ? prev : current;
                }
                return prev;
            }).endTimestamp;
        }
        return this._hub.captureEvent({
            contexts: {
                trace: this.getTraceContext(),
            },
            spans: finishedSpans,
            start_timestamp: this.startTimestamp,
            tags: this.tags,
            timestamp: this.endTimestamp,
            transaction: this.name,
            type: 'transaction',
        });
    };
    return Transaction;
}(_span__WEBPACK_IMPORTED_MODULE_4__[/* Span */ "a"]));

//# sourceMappingURL=transaction.js.map

/***/ }),

/***/ "FGHR":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export TRACEPARENT_REGEXP */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return hasTracingEnabled; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return extractTraceparentData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getActiveTransaction; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return msToSec; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return secToMs; });
/* harmony import */ var _sentry_hub__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("lW6c");

var TRACEPARENT_REGEXP = new RegExp('^[ \\t]*' + // whitespace
    '([0-9a-f]{32})?' + // trace_id
    '-?([0-9a-f]{16})?' + // span_id
    '-?([01])?' + // sampled
    '[ \\t]*$');
/**
 * Determines if tracing is currently enabled.
 *
 * Tracing is enabled when at least one of `tracesSampleRate` and `tracesSampler` is defined in the SDK config.
 */
function hasTracingEnabled(options) {
    return 'tracesSampleRate' in options || 'tracesSampler' in options;
}
/**
 * Extract transaction context data from a `sentry-trace` header.
 *
 * @param traceparent Traceparent string
 *
 * @returns Object containing data from the header, or undefined if traceparent string is malformed
 */
function extractTraceparentData(traceparent) {
    var matches = traceparent.match(TRACEPARENT_REGEXP);
    if (matches) {
        var parentSampled = void 0;
        if (matches[3] === '1') {
            parentSampled = true;
        }
        else if (matches[3] === '0') {
            parentSampled = false;
        }
        return {
            traceId: matches[1],
            parentSampled: parentSampled,
            parentSpanId: matches[2],
        };
    }
    return undefined;
}
/** Grabs active transaction off scope, if any */
function getActiveTransaction(hub) {
    if (hub === void 0) { hub = Object(_sentry_hub__WEBPACK_IMPORTED_MODULE_0__[/* getCurrentHub */ "c"])(); }
    var _a, _b;
    return (_b = (_a = hub) === null || _a === void 0 ? void 0 : _a.getScope()) === null || _b === void 0 ? void 0 : _b.getTransaction();
}
/**
 * Converts from milliseconds to seconds
 * @param time time in ms
 */
function msToSec(time) {
    return time / 1000;
}
/**
 * Converts from seconds to milliseconds
 * @param time time in seconds
 */
function secToMs(time) {
    return time * 1000;
}
// so it can be used in manual instrumentation without necessitating a hard dependency on @sentry/utils

//# sourceMappingURL=utils.js.map

/***/ }),

/***/ "GcxT":
/***/ (function(module, exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/_app",
      function () {
        return __webpack_require__("IlR1");
      }
    ]);
  

/***/ }),

/***/ "IlR1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* WEBPACK VAR INJECTION */(function(global) {/* harmony import */ var _babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("rePB");
/* harmony import */ var react_datepicker_dist_react_datepicker_css__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("5Buo");
/* harmony import */ var react_datepicker_dist_react_datepicker_css__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(react_datepicker_dist_react_datepicker_css__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _components_Form_react_datepicker_overrides_css__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("zaks");
/* harmony import */ var _components_Form_react_datepicker_overrides_css__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_components_Form_react_datepicker_overrides_css__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _components_DocsearchInput_style_css__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("Lk7Q");
/* harmony import */ var _components_DocsearchInput_style_css__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_components_DocsearchInput_style_css__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var react_toggle_style_css__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("zTMq");
/* harmony import */ var react_toggle_style_css__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(react_toggle_style_css__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _docsearch_css__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("Lfjm");
/* harmony import */ var _docsearch_css__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_docsearch_css__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("q1tI");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__("g4pe");
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__("/MKj");
/* harmony import */ var _reducers__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__("cokx");
/* harmony import */ var _utils_context__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__("jMmE");
/* harmony import */ var react_toast_notifications__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__("tbn6");
/* harmony import */ var react_toast_notifications__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(react_toast_notifications__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var _utils_theme__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__("BYIe");
/* harmony import */ var lodash_get__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__("mwIZ");
/* harmony import */ var lodash_get__WEBPACK_IMPORTED_MODULE_13___default = /*#__PURE__*/__webpack_require__.n(lodash_get__WEBPACK_IMPORTED_MODULE_13__);
/* harmony import */ var _utils_env__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__("5JAB");
/* harmony import */ var _sentry_react__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__("3CEA");
/* harmony import */ var _sentry_tracing__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__("aI3+");
/* harmony import */ var prism_react_renderer_prism__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__("SVOR");
/* harmony import */ var _constants_styles_app__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__("/F9L");
/* harmony import */ var _constants_styles_overrides__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__("xUM1");
/* harmony import */ var _constants_styles_blocks__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__("E79Q");
/* harmony import */ var _constants_styles_shimmer__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__("moWa");

var __jsx = react__WEBPACK_IMPORTED_MODULE_6___default.a.createElement;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }






















(typeof global !== "undefined" ? global : window).Prism = prism_react_renderer_prism__WEBPACK_IMPORTED_MODULE_17__[/* default */ "a"];

__webpack_require__("QWvX");

_sentry_react__WEBPACK_IMPORTED_MODULE_15__[/* init */ "e"]({
  enabled: true,
  dsn: Object(_utils_env__WEBPACK_IMPORTED_MODULE_14__[/* getConfig */ "a"])("SENTRY_DSN"),
  integrations: [new _sentry_tracing__WEBPACK_IMPORTED_MODULE_16__[/* Integrations */ "a"].BrowserTracing({
    tracingOrigins: [Object(_utils_env__WEBPACK_IMPORTED_MODULE_14__[/* getConfig */ "a"])("API_ROOT")],
    beforeNavigate: function beforeNavigate(context) {
      return _objectSpread(_objectSpread({}, context), {}, {
        // You could use your UI's routing library to find the matching
        // route template here. We don't have one right now, so do some basic
        // parameter replacements.
        name: window.location.pathname.replace(/\d+/g, "<digits>").replace(/[a-f0-9]{32}/g, "<hash>")
      });
    }
  })],
  // We recommend adjusting this value in production, or using tracesSampler
  // for finer control
  tracesSampleRate: 0.1
});

var App = function App(_ref) {
  var Component = _ref.Component,
      pageProps = _ref.pageProps;
  var store = Object(_reducers__WEBPACK_IMPORTED_MODULE_9__[/* useStore */ "b"])(pageProps.initialReduxState);
  var themeInput = lodash_get__WEBPACK_IMPORTED_MODULE_13___default()(pageProps, "theme.data", {});
  var brandTheme = Object(_utils_theme__WEBPACK_IMPORTED_MODULE_12__[/* getBrandTheme */ "c"])(themeInput);

  var _getAppStyles = Object(_constants_styles_app__WEBPACK_IMPORTED_MODULE_18__[/* getAppStyles */ "a"])(brandTheme),
      appStyles = _getAppStyles.styles;

  var _getOverrideStyles = Object(_constants_styles_overrides__WEBPACK_IMPORTED_MODULE_19__[/* getOverrideStyles */ "a"])(brandTheme),
      overrideStyles = _getOverrideStyles.styles;

  var _getBlocksStyles = Object(_constants_styles_blocks__WEBPACK_IMPORTED_MODULE_20__[/* getBlocksStyles */ "a"])(brandTheme),
      blocksStyles = _getBlocksStyles.styles;

  var _getShimmerStyles = Object(_constants_styles_shimmer__WEBPACK_IMPORTED_MODULE_21__[/* getShimmerStyles */ "a"])(),
      shimmerStyles = _getShimmerStyles.styles;

  return __jsx(react__WEBPACK_IMPORTED_MODULE_6__["Fragment"], null, __jsx(next_head__WEBPACK_IMPORTED_MODULE_7___default.a, null, __jsx("meta", {
    name: "viewport",
    content: "width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no"
  })), __jsx(_utils_context__WEBPACK_IMPORTED_MODULE_10__[/* ViewportProvider */ "a"], null, __jsx(react_toast_notifications__WEBPACK_IMPORTED_MODULE_11__["ToastProvider"], {
    placement: "bottom-left"
  }, __jsx(react_redux__WEBPACK_IMPORTED_MODULE_8__[/* Provider */ "a"], {
    store: store
  }, __jsx(Component, pageProps)))), appStyles, overrideStyles, blocksStyles, shimmerStyles);
};

/* harmony default export */ __webpack_exports__["default"] = (App);
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__("yLpj")))

/***/ }),

/***/ "Lfjm":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "Lk7Q":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "MBYv":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DEFAULT_IDLE_TIMEOUT; });
/* unused harmony export IdleTransactionSpanRecorder */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return IdleTransaction; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("mrSG");
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("9/Zf");
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("8LbN");
/* harmony import */ var _span__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("SYqL");
/* harmony import */ var _spanstatus__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("bju/");
/* harmony import */ var _transaction__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("EldZ");





var DEFAULT_IDLE_TIMEOUT = 1000;
/**
 * @inheritDoc
 */
var IdleTransactionSpanRecorder = /** @class */ (function (_super) {
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__[/* __extends */ "b"])(IdleTransactionSpanRecorder, _super);
    function IdleTransactionSpanRecorder(_pushActivity, _popActivity, transactionSpanId, maxlen) {
        if (transactionSpanId === void 0) { transactionSpanId = ''; }
        var _this = _super.call(this, maxlen) || this;
        _this._pushActivity = _pushActivity;
        _this._popActivity = _popActivity;
        _this.transactionSpanId = transactionSpanId;
        return _this;
    }
    /**
     * @inheritDoc
     */
    IdleTransactionSpanRecorder.prototype.add = function (span) {
        var _this = this;
        // We should make sure we do not push and pop activities for
        // the transaction that this span recorder belongs to.
        if (span.spanId !== this.transactionSpanId) {
            // We patch span.finish() to pop an activity after setting an endTimestamp.
            span.finish = function (endTimestamp) {
                span.endTimestamp = typeof endTimestamp === 'number' ? endTimestamp : Object(_sentry_utils__WEBPACK_IMPORTED_MODULE_1__[/* timestampWithMs */ "i"])();
                _this._popActivity(span.spanId);
            };
            // We should only push new activities if the span does not have an end timestamp.
            if (span.endTimestamp === undefined) {
                this._pushActivity(span.spanId);
            }
        }
        _super.prototype.add.call(this, span);
    };
    return IdleTransactionSpanRecorder;
}(_span__WEBPACK_IMPORTED_MODULE_3__[/* SpanRecorder */ "b"]));

/**
 * An IdleTransaction is a transaction that automatically finishes. It does this by tracking child spans as activities.
 * You can have multiple IdleTransactions active, but if the `onScope` option is specified, the idle transaction will
 * put itself on the scope on creation.
 */
var IdleTransaction = /** @class */ (function (_super) {
    Object(tslib__WEBPACK_IMPORTED_MODULE_0__[/* __extends */ "b"])(IdleTransaction, _super);
    function IdleTransaction(transactionContext, _idleHub, 
    // The time to wait in ms until the idle transaction will be finished. Default: 1000
    _idleTimeout, 
    // If an idle transaction should be put itself on and off the scope automatically.
    _onScope) {
        if (_idleTimeout === void 0) { _idleTimeout = DEFAULT_IDLE_TIMEOUT; }
        if (_onScope === void 0) { _onScope = false; }
        var _this = _super.call(this, transactionContext, _idleHub) || this;
        _this._idleHub = _idleHub;
        _this._idleTimeout = _idleTimeout;
        _this._onScope = _onScope;
        // Activities store a list of active spans
        _this.activities = {};
        // Stores reference to the timeout that calls _beat().
        _this._heartbeatTimer = 0;
        // Amount of times heartbeat has counted. Will cause transaction to finish after 3 beats.
        _this._heartbeatCounter = 0;
        // We should not use heartbeat if we finished a transaction
        _this._finished = false;
        _this._beforeFinishCallbacks = [];
        if (_idleHub && _onScope) {
            // There should only be one active transaction on the scope
            clearActiveTransaction(_idleHub);
            // We set the transaction here on the scope so error events pick up the trace
            // context and attach it to the error.
            _sentry_utils__WEBPACK_IMPORTED_MODULE_2__[/* logger */ "a"].log("Setting idle transaction on scope. Span ID: " + _this.spanId);
            _idleHub.configureScope(function (scope) { return scope.setSpan(_this); });
        }
        return _this;
    }
    /** {@inheritDoc} */
    IdleTransaction.prototype.finish = function (endTimestamp) {
        var e_1, _a;
        var _this = this;
        if (endTimestamp === void 0) { endTimestamp = Object(_sentry_utils__WEBPACK_IMPORTED_MODULE_1__[/* timestampWithMs */ "i"])(); }
        this._finished = true;
        this.activities = {};
        if (this.spanRecorder) {
            _sentry_utils__WEBPACK_IMPORTED_MODULE_2__[/* logger */ "a"].log('[Tracing] finishing IdleTransaction', new Date(endTimestamp * 1000).toISOString(), this.op);
            try {
                for (var _b = Object(tslib__WEBPACK_IMPORTED_MODULE_0__[/* __values */ "f"])(this._beforeFinishCallbacks), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var callback = _c.value;
                    callback(this, endTimestamp);
                }
            }
            catch (e_1_1) { e_1 = { error: e_1_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_1) throw e_1.error; }
            }
            this.spanRecorder.spans = this.spanRecorder.spans.filter(function (span) {
                // If we are dealing with the transaction itself, we just return it
                if (span.spanId === _this.spanId) {
                    return true;
                }
                // We cancel all pending spans with status "cancelled" to indicate the idle transaction was finished early
                if (!span.endTimestamp) {
                    span.endTimestamp = endTimestamp;
                    span.setStatus(_spanstatus__WEBPACK_IMPORTED_MODULE_4__[/* SpanStatus */ "a"].Cancelled);
                    _sentry_utils__WEBPACK_IMPORTED_MODULE_2__[/* logger */ "a"].log('[Tracing] cancelling span since transaction ended early', JSON.stringify(span, undefined, 2));
                }
                var keepSpan = span.startTimestamp < endTimestamp;
                if (!keepSpan) {
                    _sentry_utils__WEBPACK_IMPORTED_MODULE_2__[/* logger */ "a"].log('[Tracing] discarding Span since it happened after Transaction was finished', JSON.stringify(span, undefined, 2));
                }
                return keepSpan;
            });
            // this._onScope is true if the transaction was previously on the scope.
            if (this._onScope) {
                clearActiveTransaction(this._idleHub);
            }
            _sentry_utils__WEBPACK_IMPORTED_MODULE_2__[/* logger */ "a"].log('[Tracing] flushing IdleTransaction');
        }
        else {
            _sentry_utils__WEBPACK_IMPORTED_MODULE_2__[/* logger */ "a"].log('[Tracing] No active IdleTransaction');
        }
        return _super.prototype.finish.call(this, endTimestamp);
    };
    /**
     * Register a callback function that gets excecuted before the transaction finishes.
     * Useful for cleanup or if you want to add any additional spans based on current context.
     *
     * This is exposed because users have no other way of running something before an idle transaction
     * finishes.
     */
    IdleTransaction.prototype.registerBeforeFinishCallback = function (callback) {
        this._beforeFinishCallbacks.push(callback);
    };
    /**
     * @inheritDoc
     */
    IdleTransaction.prototype.initSpanRecorder = function (maxlen) {
        var _this = this;
        if (!this.spanRecorder) {
            this._initTimeout = setTimeout(function () {
                if (!_this._finished) {
                    _this.finish();
                }
            }, this._idleTimeout);
            var pushActivity = function (id) {
                if (_this._finished) {
                    return;
                }
                _this._pushActivity(id);
            };
            var popActivity = function (id) {
                if (_this._finished) {
                    return;
                }
                _this._popActivity(id);
            };
            this.spanRecorder = new IdleTransactionSpanRecorder(pushActivity, popActivity, this.spanId, maxlen);
            // Start heartbeat so that transactions do not run forever.
            _sentry_utils__WEBPACK_IMPORTED_MODULE_2__[/* logger */ "a"].log('Starting heartbeat');
            this._pingHeartbeat();
        }
        this.spanRecorder.add(this);
    };
    /**
     * Start tracking a specific activity.
     * @param spanId The span id that represents the activity
     */
    IdleTransaction.prototype._pushActivity = function (spanId) {
        if (this._initTimeout) {
            clearTimeout(this._initTimeout);
            this._initTimeout = undefined;
        }
        _sentry_utils__WEBPACK_IMPORTED_MODULE_2__[/* logger */ "a"].log("[Tracing] pushActivity: " + spanId);
        this.activities[spanId] = true;
        _sentry_utils__WEBPACK_IMPORTED_MODULE_2__[/* logger */ "a"].log('[Tracing] new activities count', Object.keys(this.activities).length);
    };
    /**
     * Remove an activity from usage
     * @param spanId The span id that represents the activity
     */
    IdleTransaction.prototype._popActivity = function (spanId) {
        var _this = this;
        if (this.activities[spanId]) {
            _sentry_utils__WEBPACK_IMPORTED_MODULE_2__[/* logger */ "a"].log("[Tracing] popActivity " + spanId);
            // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
            delete this.activities[spanId];
            _sentry_utils__WEBPACK_IMPORTED_MODULE_2__[/* logger */ "a"].log('[Tracing] new activities count', Object.keys(this.activities).length);
        }
        if (Object.keys(this.activities).length === 0) {
            var timeout = this._idleTimeout;
            // We need to add the timeout here to have the real endtimestamp of the transaction
            // Remember timestampWithMs is in seconds, timeout is in ms
            var end_1 = Object(_sentry_utils__WEBPACK_IMPORTED_MODULE_1__[/* timestampWithMs */ "i"])() + timeout / 1000;
            setTimeout(function () {
                if (!_this._finished) {
                    _this.finish(end_1);
                }
            }, timeout);
        }
    };
    /**
     * Checks when entries of this.activities are not changing for 3 beats.
     * If this occurs we finish the transaction.
     */
    IdleTransaction.prototype._beat = function () {
        clearTimeout(this._heartbeatTimer);
        // We should not be running heartbeat if the idle transaction is finished.
        if (this._finished) {
            return;
        }
        var keys = Object.keys(this.activities);
        var heartbeatString = keys.length ? keys.reduce(function (prev, current) { return prev + current; }) : '';
        if (heartbeatString === this._prevHeartbeatString) {
            this._heartbeatCounter += 1;
        }
        else {
            this._heartbeatCounter = 1;
        }
        this._prevHeartbeatString = heartbeatString;
        if (this._heartbeatCounter >= 3) {
            _sentry_utils__WEBPACK_IMPORTED_MODULE_2__[/* logger */ "a"].log("[Tracing] Transaction finished because of no change for 3 heart beats");
            this.setStatus(_spanstatus__WEBPACK_IMPORTED_MODULE_4__[/* SpanStatus */ "a"].DeadlineExceeded);
            this.setTag('heartbeat', 'failed');
            this.finish();
        }
        else {
            this._pingHeartbeat();
        }
    };
    /**
     * Pings the heartbeat
     */
    IdleTransaction.prototype._pingHeartbeat = function () {
        var _this = this;
        _sentry_utils__WEBPACK_IMPORTED_MODULE_2__[/* logger */ "a"].log("pinging Heartbeat -> current counter: " + this._heartbeatCounter);
        this._heartbeatTimer = setTimeout(function () {
            _this._beat();
        }, 5000);
    };
    return IdleTransaction;
}(_transaction__WEBPACK_IMPORTED_MODULE_5__[/* Transaction */ "a"]));

/**
 * Reset active transaction on scope
 */
function clearActiveTransaction(hub) {
    if (hub) {
        var scope = hub.getScope();
        if (scope) {
            var transaction = scope.getTransaction();
            if (transaction) {
                scope.setSpan(undefined);
            }
        }
    }
}
//# sourceMappingURL=idletransaction.js.map

/***/ }),

/***/ "QWvX":
/***/ (function(module, exports) {

Prism.languages.javascript = Prism.languages.extend('clike', {
	'class-name': [
		Prism.languages.clike['class-name'],
		{
			pattern: /(^|[^$\w\xA0-\uFFFF])[_$A-Z\xA0-\uFFFF][$\w\xA0-\uFFFF]*(?=\.(?:prototype|constructor))/,
			lookbehind: true
		}
	],
	'keyword': [
		{
			pattern: /((?:^|})\s*)(?:catch|finally)\b/,
			lookbehind: true
		},
		{
			pattern: /(^|[^.])\b(?:as|async(?=\s*(?:function\b|\(|[$\w\xA0-\uFFFF]|$))|await|break|case|class|const|continue|debugger|default|delete|do|else|enum|export|extends|for|from|function|get|if|implements|import|in|instanceof|interface|let|new|null|of|package|private|protected|public|return|set|static|super|switch|this|throw|try|typeof|undefined|var|void|while|with|yield)\b/,
			lookbehind: true
		},
	],
	'number': /\b(?:(?:0[xX](?:[\dA-Fa-f](?:_[\dA-Fa-f])?)+|0[bB](?:[01](?:_[01])?)+|0[oO](?:[0-7](?:_[0-7])?)+)n?|(?:\d(?:_\d)?)+n|NaN|Infinity)\b|(?:\b(?:\d(?:_\d)?)+\.?(?:\d(?:_\d)?)*|\B\.(?:\d(?:_\d)?)+)(?:[Ee][+-]?(?:\d(?:_\d)?)+)?/,
	// Allow for all non-ASCII characters (See http://stackoverflow.com/a/2008444)
	'function': /#?[_$a-zA-Z\xA0-\uFFFF][$\w\xA0-\uFFFF]*(?=\s*(?:\.\s*(?:apply|bind|call)\s*)?\()/,
	'operator': /-[-=]?|\+[+=]?|!=?=?|<<?=?|>>?>?=?|=(?:==?|>)?|&[&=]?|\|[|=]?|\*\*?=?|\/=?|~|\^=?|%=?|\?|\.{3}/
});

Prism.languages.javascript['class-name'][0].pattern = /(\b(?:class|interface|extends|implements|instanceof|new)\s+)[\w.\\]+/;

Prism.languages.insertBefore('javascript', 'keyword', {
	'regex': {
		pattern: /((?:^|[^$\w\xA0-\uFFFF."'\])\s])\s*)\/(\[(?:[^\]\\\r\n]|\\.)*]|\\.|[^/\\\[\r\n])+\/[gimyus]{0,6}(?=\s*($|[\r\n,.;})\]]))/,
		lookbehind: true,
		greedy: true
	},
	// This must be declared before keyword because we use "function" inside the look-forward
	'function-variable': {
		pattern: /#?[_$a-zA-Z\xA0-\uFFFF][$\w\xA0-\uFFFF]*(?=\s*[=:]\s*(?:async\s*)?(?:\bfunction\b|(?:\((?:[^()]|\([^()]*\))*\)|[_$a-zA-Z\xA0-\uFFFF][$\w\xA0-\uFFFF]*)\s*=>))/,
		alias: 'function'
	},
	'parameter': [
		{
			pattern: /(function(?:\s+[_$A-Za-z\xA0-\uFFFF][$\w\xA0-\uFFFF]*)?\s*\(\s*)(?!\s)(?:[^()]|\([^()]*\))+?(?=\s*\))/,
			lookbehind: true,
			inside: Prism.languages.javascript
		},
		{
			pattern: /[_$a-z\xA0-\uFFFF][$\w\xA0-\uFFFF]*(?=\s*=>)/i,
			inside: Prism.languages.javascript
		},
		{
			pattern: /(\(\s*)(?!\s)(?:[^()]|\([^()]*\))+?(?=\s*\)\s*=>)/,
			lookbehind: true,
			inside: Prism.languages.javascript
		},
		{
			pattern: /((?:\b|\s|^)(?!(?:as|async|await|break|case|catch|class|const|continue|debugger|default|delete|do|else|enum|export|extends|finally|for|from|function|get|if|implements|import|in|instanceof|interface|let|new|null|of|package|private|protected|public|return|set|static|super|switch|this|throw|try|typeof|undefined|var|void|while|with|yield)(?![$\w\xA0-\uFFFF]))(?:[_$A-Za-z\xA0-\uFFFF][$\w\xA0-\uFFFF]*\s*)\(\s*)(?!\s)(?:[^()]|\([^()]*\))+?(?=\s*\)\s*\{)/,
			lookbehind: true,
			inside: Prism.languages.javascript
		}
	],
	'constant': /\b[A-Z](?:[A-Z_]|\dx?)*\b/
});

Prism.languages.insertBefore('javascript', 'string', {
	'template-string': {
		pattern: /`(?:\\[\s\S]|\${(?:[^{}]|{(?:[^{}]|{[^}]*})*})+}|(?!\${)[^\\`])*`/,
		greedy: true,
		inside: {
			'template-punctuation': {
				pattern: /^`|`$/,
				alias: 'string'
			},
			'interpolation': {
				pattern: /((?:^|[^\\])(?:\\{2})*)\${(?:[^{}]|{(?:[^{}]|{[^}]*})*})+}/,
				lookbehind: true,
				inside: {
					'interpolation-punctuation': {
						pattern: /^\${|}$/,
						alias: 'punctuation'
					},
					rest: Prism.languages.javascript
				}
			},
			'string': /[\s\S]+/
		}
	}
});

if (Prism.languages.markup) {
	Prism.languages.markup.tag.addInlined('script', 'javascript');
}

Prism.languages.js = Prism.languages.javascript;


/***/ }),

/***/ "SYqL":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return SpanRecorder; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Span; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("mrSG");
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("9/Zf");
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("6PXS");
/* harmony import */ var _spanstatus__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("bju/");



/**
 * Keeps track of finished spans for a given transaction
 * @internal
 * @hideconstructor
 * @hidden
 */
var SpanRecorder = /** @class */ (function () {
    function SpanRecorder(maxlen) {
        if (maxlen === void 0) { maxlen = 1000; }
        this.spans = [];
        this._maxlen = maxlen;
    }
    /**
     * This is just so that we don't run out of memory while recording a lot
     * of spans. At some point we just stop and flush out the start of the
     * trace tree (i.e.the first n spans with the smallest
     * start_timestamp).
     */
    SpanRecorder.prototype.add = function (span) {
        if (this.spans.length > this._maxlen) {
            span.spanRecorder = undefined;
        }
        else {
            this.spans.push(span);
        }
    };
    return SpanRecorder;
}());

/**
 * Span contains all data about a span
 */
var Span = /** @class */ (function () {
    /**
     * You should never call the constructor manually, always use `hub.startSpan()`.
     * @internal
     * @hideconstructor
     * @hidden
     */
    function Span(spanContext) {
        /**
         * @inheritDoc
         */
        this.traceId = Object(_sentry_utils__WEBPACK_IMPORTED_MODULE_1__[/* uuid4 */ "j"])();
        /**
         * @inheritDoc
         */
        this.spanId = Object(_sentry_utils__WEBPACK_IMPORTED_MODULE_1__[/* uuid4 */ "j"])().substring(16);
        /**
         * Timestamp in seconds when the span was created.
         */
        this.startTimestamp = Object(_sentry_utils__WEBPACK_IMPORTED_MODULE_1__[/* timestampWithMs */ "i"])();
        /**
         * @inheritDoc
         */
        this.tags = {};
        /**
         * @inheritDoc
         */
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        this.data = {};
        if (!spanContext) {
            return this;
        }
        if (spanContext.traceId) {
            this.traceId = spanContext.traceId;
        }
        if (spanContext.spanId) {
            this.spanId = spanContext.spanId;
        }
        if (spanContext.parentSpanId) {
            this.parentSpanId = spanContext.parentSpanId;
        }
        // We want to include booleans as well here
        if ('sampled' in spanContext) {
            this.sampled = spanContext.sampled;
        }
        if (spanContext.op) {
            this.op = spanContext.op;
        }
        if (spanContext.description) {
            this.description = spanContext.description;
        }
        if (spanContext.data) {
            this.data = spanContext.data;
        }
        if (spanContext.tags) {
            this.tags = spanContext.tags;
        }
        if (spanContext.status) {
            this.status = spanContext.status;
        }
        if (spanContext.startTimestamp) {
            this.startTimestamp = spanContext.startTimestamp;
        }
        if (spanContext.endTimestamp) {
            this.endTimestamp = spanContext.endTimestamp;
        }
    }
    /**
     * @inheritDoc
     * @deprecated
     */
    Span.prototype.child = function (spanContext) {
        return this.startChild(spanContext);
    };
    /**
     * @inheritDoc
     */
    Span.prototype.startChild = function (spanContext) {
        var span = new Span(Object(tslib__WEBPACK_IMPORTED_MODULE_0__[/* __assign */ "a"])(Object(tslib__WEBPACK_IMPORTED_MODULE_0__[/* __assign */ "a"])({}, spanContext), { parentSpanId: this.spanId, sampled: this.sampled, traceId: this.traceId }));
        span.spanRecorder = this.spanRecorder;
        if (span.spanRecorder) {
            span.spanRecorder.add(span);
        }
        return span;
    };
    /**
     * @inheritDoc
     */
    Span.prototype.setTag = function (key, value) {
        var _a;
        this.tags = Object(tslib__WEBPACK_IMPORTED_MODULE_0__[/* __assign */ "a"])(Object(tslib__WEBPACK_IMPORTED_MODULE_0__[/* __assign */ "a"])({}, this.tags), (_a = {}, _a[key] = value, _a));
        return this;
    };
    /**
     * @inheritDoc
     */
    // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/explicit-module-boundary-types
    Span.prototype.setData = function (key, value) {
        var _a;
        this.data = Object(tslib__WEBPACK_IMPORTED_MODULE_0__[/* __assign */ "a"])(Object(tslib__WEBPACK_IMPORTED_MODULE_0__[/* __assign */ "a"])({}, this.data), (_a = {}, _a[key] = value, _a));
        return this;
    };
    /**
     * @inheritDoc
     */
    Span.prototype.setStatus = function (value) {
        this.status = value;
        return this;
    };
    /**
     * @inheritDoc
     */
    Span.prototype.setHttpStatus = function (httpStatus) {
        this.setTag('http.status_code', String(httpStatus));
        var spanStatus = _spanstatus__WEBPACK_IMPORTED_MODULE_3__[/* SpanStatus */ "a"].fromHttpCode(httpStatus);
        if (spanStatus !== _spanstatus__WEBPACK_IMPORTED_MODULE_3__[/* SpanStatus */ "a"].UnknownError) {
            this.setStatus(spanStatus);
        }
        return this;
    };
    /**
     * @inheritDoc
     */
    Span.prototype.isSuccess = function () {
        return this.status === _spanstatus__WEBPACK_IMPORTED_MODULE_3__[/* SpanStatus */ "a"].Ok;
    };
    /**
     * @inheritDoc
     */
    Span.prototype.finish = function (endTimestamp) {
        this.endTimestamp = typeof endTimestamp === 'number' ? endTimestamp : Object(_sentry_utils__WEBPACK_IMPORTED_MODULE_1__[/* timestampWithMs */ "i"])();
    };
    /**
     * @inheritDoc
     */
    Span.prototype.toTraceparent = function () {
        var sampledString = '';
        if (this.sampled !== undefined) {
            sampledString = this.sampled ? '-1' : '-0';
        }
        return this.traceId + "-" + this.spanId + sampledString;
    };
    /**
     * @inheritDoc
     */
    Span.prototype.getTraceContext = function () {
        return Object(_sentry_utils__WEBPACK_IMPORTED_MODULE_2__[/* dropUndefinedKeys */ "a"])({
            data: Object.keys(this.data).length > 0 ? this.data : undefined,
            description: this.description,
            op: this.op,
            parent_span_id: this.parentSpanId,
            span_id: this.spanId,
            status: this.status,
            tags: Object.keys(this.tags).length > 0 ? this.tags : undefined,
            trace_id: this.traceId,
        });
    };
    /**
     * @inheritDoc
     */
    Span.prototype.toJSON = function () {
        return Object(_sentry_utils__WEBPACK_IMPORTED_MODULE_2__[/* dropUndefinedKeys */ "a"])({
            data: Object.keys(this.data).length > 0 ? this.data : undefined,
            description: this.description,
            op: this.op,
            parent_span_id: this.parentSpanId,
            span_id: this.spanId,
            start_timestamp: this.startTimestamp,
            status: this.status,
            tags: Object.keys(this.tags).length > 0 ? this.tags : undefined,
            timestamp: this.endTimestamp,
            trace_id: this.traceId,
        });
    };
    return Span;
}());

//# sourceMappingURL=span.js.map

/***/ }),

/***/ "aI3+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, "a", function() { return /* binding */ Integrations; });

// UNUSED EXPORTS: Span, Transaction, SpanStatus, addExtensionMethods, extractTraceparentData, getActiveTransaction, hasTracingEnabled, stripUrlQueryAndFragment

// NAMESPACE OBJECT: ./node_modules/@sentry/tracing/esm/integrations/index.js
var integrations_namespaceObject = {};
__webpack_require__.r(integrations_namespaceObject);
__webpack_require__.d(integrations_namespaceObject, "Express", function() { return express_Express; });

// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__("mrSG");

// EXTERNAL MODULE: ./node_modules/@sentry/utils/esm/logger.js
var logger = __webpack_require__("8LbN");

// EXTERNAL MODULE: ./node_modules/@sentry/tracing/esm/hubextensions.js
var hubextensions = __webpack_require__("Cpvd");

// EXTERNAL MODULE: ./node_modules/@sentry/tracing/esm/idletransaction.js
var idletransaction = __webpack_require__("MBYv");

// EXTERNAL MODULE: ./node_modules/@sentry/tracing/esm/spanstatus.js
var spanstatus = __webpack_require__("bju/");

// EXTERNAL MODULE: ./node_modules/@sentry/tracing/esm/utils.js
var utils = __webpack_require__("FGHR");

// EXTERNAL MODULE: ./node_modules/@sentry/utils/esm/misc.js
var misc = __webpack_require__("9/Zf");

// CONCATENATED MODULE: ./node_modules/@sentry/tracing/esm/browser/backgroundtab.js



var global = Object(misc["e" /* getGlobalObject */])();
/**
 * Add a listener that cancels and finishes a transaction when the global
 * document is hidden.
 */
function registerBackgroundTabDetection() {
    if (global && global.document) {
        global.document.addEventListener('visibilitychange', function () {
            var activeTransaction = Object(utils["b" /* getActiveTransaction */])();
            if (global.document.hidden && activeTransaction) {
                logger["a" /* logger */].log("[Tracing] Transaction: " + spanstatus["a" /* SpanStatus */].Cancelled + " -> since tab moved to the background, op: " + activeTransaction.op);
                // We should not set status if it is already set, this prevent important statuses like
                // error or data loss from being overwritten on transaction.
                if (!activeTransaction.status) {
                    activeTransaction.setStatus(spanstatus["a" /* SpanStatus */].Cancelled);
                }
                activeTransaction.setTag('visibilitychange', 'document.hidden');
                activeTransaction.finish();
            }
        });
    }
    else {
        logger["a" /* logger */].warn('[Tracing] Could not set up background tab detection due to lack of global document');
    }
}
//# sourceMappingURL=backgroundtab.js.map
// CONCATENATED MODULE: ./node_modules/@sentry/tracing/esm/browser/metrics.js



var metrics_global = Object(misc["e" /* getGlobalObject */])();
/** Class tracking metrics  */
var metrics_MetricsInstrumentation = /** @class */ (function () {
    function MetricsInstrumentation() {
        this._lcp = {};
        this._performanceCursor = 0;
        this._forceLCP = function () {
            /* No-op, replaced later if LCP API is available. */
            return;
        };
        if (metrics_global && metrics_global.performance) {
            if (metrics_global.performance.mark) {
                metrics_global.performance.mark('sentry-tracing-init');
            }
            this._trackLCP();
        }
    }
    /** Add performance related spans to a transaction */
    MetricsInstrumentation.prototype.addPerformanceEntries = function (transaction) {
        if (!metrics_global || !metrics_global.performance || !metrics_global.performance.getEntries) {
            // Gatekeeper if performance API not available
            return;
        }
        logger["a" /* logger */].log('[Tracing] Adding & adjusting spans using Performance API');
        // TODO(fixme): depending on the 'op' directly is brittle.
        if (transaction.op === 'pageload') {
            // Force any pending records to be dispatched.
            this._forceLCP();
            if (this._lcp) {
                // Set the last observed LCP score.
                transaction.setData('_sentry_web_vitals', { LCP: this._lcp });
            }
        }
        var timeOrigin = Object(utils["d" /* msToSec */])(performance.timeOrigin);
        var entryScriptSrc;
        if (metrics_global.document) {
            // eslint-disable-next-line @typescript-eslint/prefer-for-of
            for (var i = 0; i < document.scripts.length; i++) {
                // We go through all scripts on the page and look for 'data-entry'
                // We remember the name and measure the time between this script finished loading and
                // our mark 'sentry-tracing-init'
                if (document.scripts[i].dataset.entry === 'true') {
                    entryScriptSrc = document.scripts[i].src;
                    break;
                }
            }
        }
        var entryScriptStartTimestamp;
        var tracingInitMarkStartTime;
        metrics_global.performance
            .getEntries()
            .slice(this._performanceCursor)
            .forEach(function (entry) {
            var startTime = Object(utils["d" /* msToSec */])(entry.startTime);
            var duration = Object(utils["d" /* msToSec */])(entry.duration);
            if (transaction.op === 'navigation' && timeOrigin + startTime < transaction.startTimestamp) {
                return;
            }
            switch (entry.entryType) {
                case 'navigation':
                    addNavigationSpans(transaction, entry, timeOrigin);
                    break;
                case 'mark':
                case 'paint':
                case 'measure': {
                    var startTimestamp = addMeasureSpans(transaction, entry, startTime, duration, timeOrigin);
                    if (tracingInitMarkStartTime === undefined && entry.name === 'sentry-tracing-init') {
                        tracingInitMarkStartTime = startTimestamp;
                    }
                    break;
                }
                case 'resource': {
                    var resourceName = entry.name.replace(window.location.origin, '');
                    var endTimestamp = addResourceSpans(transaction, entry, resourceName, startTime, duration, timeOrigin);
                    // We remember the entry script end time to calculate the difference to the first init mark
                    if (entryScriptStartTimestamp === undefined && (entryScriptSrc || '').indexOf(resourceName) > -1) {
                        entryScriptStartTimestamp = endTimestamp;
                    }
                    break;
                }
                default:
                // Ignore other entry types.
            }
        });
        if (entryScriptStartTimestamp !== undefined && tracingInitMarkStartTime !== undefined) {
            _startChild(transaction, {
                description: 'evaluation',
                endTimestamp: tracingInitMarkStartTime,
                op: 'script',
                startTimestamp: entryScriptStartTimestamp,
            });
        }
        this._performanceCursor = Math.max(performance.getEntries().length - 1, 0);
    };
    /** Starts tracking the Largest Contentful Paint on the current page. */
    MetricsInstrumentation.prototype._trackLCP = function () {
        var _this = this;
        // Based on reference implementation from https://web.dev/lcp/#measure-lcp-in-javascript.
        // Use a try/catch instead of feature detecting `largest-contentful-paint`
        // support, since some browsers throw when using the new `type` option.
        // https://bugs.webkit.org/show_bug.cgi?id=209216
        try {
            // Keep track of whether (and when) the page was first hidden, see:
            // https://github.com/w3c/page-visibility/issues/29
            // NOTE: ideally this check would be performed in the document <head>
            // to avoid cases where the visibility state changes before this code runs.
            var firstHiddenTime_1 = document.visibilityState === 'hidden' ? 0 : Infinity;
            document.addEventListener('visibilitychange', function (event) {
                firstHiddenTime_1 = Math.min(firstHiddenTime_1, event.timeStamp);
            }, { once: true });
            var updateLCP_1 = function (entry) {
                // Only include an LCP entry if the page wasn't hidden prior to
                // the entry being dispatched. This typically happens when a page is
                // loaded in a background tab.
                if (entry.startTime < firstHiddenTime_1) {
                    // NOTE: the `startTime` value is a getter that returns the entry's
                    // `renderTime` value, if available, or its `loadTime` value otherwise.
                    // The `renderTime` value may not be available if the element is an image
                    // that's loaded cross-origin without the `Timing-Allow-Origin` header.
                    _this._lcp = Object(tslib_es6["a" /* __assign */])(Object(tslib_es6["a" /* __assign */])(Object(tslib_es6["a" /* __assign */])({}, (entry.id && { elementId: entry.id })), (entry.size && { elementSize: entry.size })), { value: entry.startTime });
                }
            };
            // Create a PerformanceObserver that calls `updateLCP` for each entry.
            var po_1 = new PerformanceObserver(function (entryList) {
                entryList.getEntries().forEach(updateLCP_1);
            });
            // Observe entries of type `largest-contentful-paint`, including buffered entries,
            // i.e. entries that occurred before calling `observe()` below.
            po_1.observe({
                buffered: true,
                // @ts-ignore type does not exist on obj
                type: 'largest-contentful-paint',
            });
            this._forceLCP = function () {
                if (po_1.takeRecords) {
                    po_1.takeRecords().forEach(updateLCP_1);
                }
            };
        }
        catch (e) {
            // Do nothing if the browser doesn't support this API.
        }
    };
    return MetricsInstrumentation;
}());

/** Instrument navigation entries */
function addNavigationSpans(transaction, entry, timeOrigin) {
    addPerformanceNavigationTiming(transaction, entry, 'unloadEvent', timeOrigin);
    addPerformanceNavigationTiming(transaction, entry, 'domContentLoadedEvent', timeOrigin);
    addPerformanceNavigationTiming(transaction, entry, 'loadEvent', timeOrigin);
    addPerformanceNavigationTiming(transaction, entry, 'connect', timeOrigin);
    addPerformanceNavigationTiming(transaction, entry, 'domainLookup', timeOrigin);
    addRequest(transaction, entry, timeOrigin);
}
/** Create measure related spans */
function addMeasureSpans(transaction, entry, startTime, duration, timeOrigin) {
    var measureStartTimestamp = timeOrigin + startTime;
    var measureEndTimestamp = measureStartTimestamp + duration;
    _startChild(transaction, {
        description: entry.name,
        endTimestamp: measureEndTimestamp,
        op: entry.entryType,
        startTimestamp: measureStartTimestamp,
    });
    return measureStartTimestamp;
}
/** Create resource related spans */
function addResourceSpans(transaction, entry, resourceName, startTime, duration, timeOrigin) {
    // we already instrument based on fetch and xhr, so we don't need to
    // duplicate spans here.
    if (entry.initiatorType === 'xmlhttprequest' || entry.initiatorType === 'fetch') {
        return undefined;
    }
    var data = {};
    if ('transferSize' in entry) {
        data['Transfer Size'] = entry.transferSize;
    }
    if ('encodedBodySize' in entry) {
        data['Encoded Body Size'] = entry.encodedBodySize;
    }
    if ('decodedBodySize' in entry) {
        data['Decoded Body Size'] = entry.decodedBodySize;
    }
    var startTimestamp = timeOrigin + startTime;
    var endTimestamp = startTimestamp + duration;
    _startChild(transaction, {
        description: resourceName,
        endTimestamp: endTimestamp,
        op: entry.initiatorType ? "resource." + entry.initiatorType : 'resource',
        startTimestamp: startTimestamp,
        data: data,
    });
    return endTimestamp;
}
/** Create performance navigation related spans */
function addPerformanceNavigationTiming(transaction, entry, event, timeOrigin) {
    var end = entry[event + "End"];
    var start = entry[event + "Start"];
    if (!start || !end) {
        return;
    }
    _startChild(transaction, {
        description: event,
        endTimestamp: timeOrigin + Object(utils["d" /* msToSec */])(end),
        op: 'browser',
        startTimestamp: timeOrigin + Object(utils["d" /* msToSec */])(start),
    });
}
/** Create request and response related spans */
function addRequest(transaction, entry, timeOrigin) {
    _startChild(transaction, {
        description: 'request',
        endTimestamp: timeOrigin + Object(utils["d" /* msToSec */])(entry.responseEnd),
        op: 'browser',
        startTimestamp: timeOrigin + Object(utils["d" /* msToSec */])(entry.requestStart),
    });
    _startChild(transaction, {
        description: 'response',
        endTimestamp: timeOrigin + Object(utils["d" /* msToSec */])(entry.responseEnd),
        op: 'browser',
        startTimestamp: timeOrigin + Object(utils["d" /* msToSec */])(entry.responseStart),
    });
}
/**
 * Helper function to start child on transactions. This function will make sure that the transaction will
 * use the start timestamp of the created child span if it is earlier than the transactions actual
 * start timestamp.
 */
function _startChild(transaction, _a) {
    var startTimestamp = _a.startTimestamp, ctx = Object(tslib_es6["d" /* __rest */])(_a, ["startTimestamp"]);
    if (startTimestamp && transaction.startTimestamp > startTimestamp) {
        transaction.startTimestamp = startTimestamp;
    }
    return transaction.startChild(Object(tslib_es6["a" /* __assign */])({ startTimestamp: startTimestamp }, ctx));
}
//# sourceMappingURL=metrics.js.map
// EXTERNAL MODULE: ./node_modules/@sentry/utils/esm/string.js
var string = __webpack_require__("+924");

// EXTERNAL MODULE: ./node_modules/@sentry/utils/esm/instrument.js
var instrument = __webpack_require__("6hSO");

// EXTERNAL MODULE: ./node_modules/@sentry/utils/esm/is.js
var is = __webpack_require__("9AQC");

// CONCATENATED MODULE: ./node_modules/@sentry/tracing/esm/browser/request.js



var DEFAULT_TRACING_ORIGINS = ['localhost', /^\//];
var defaultRequestInstrumentionOptions = {
    traceFetch: true,
    traceXHR: true,
    tracingOrigins: DEFAULT_TRACING_ORIGINS,
};
/** Registers span creators for xhr and fetch requests  */
function registerRequestInstrumentation(_options) {
    // eslint-disable-next-line @typescript-eslint/unbound-method
    var _a = Object(tslib_es6["a" /* __assign */])(Object(tslib_es6["a" /* __assign */])({}, defaultRequestInstrumentionOptions), _options), traceFetch = _a.traceFetch, traceXHR = _a.traceXHR, tracingOrigins = _a.tracingOrigins, shouldCreateSpanForRequest = _a.shouldCreateSpanForRequest;
    // We should cache url -> decision so that we don't have to compute
    // regexp everytime we create a request.
    var urlMap = {};
    var defaultShouldCreateSpan = function (url) {
        if (urlMap[url]) {
            return urlMap[url];
        }
        var origins = tracingOrigins;
        urlMap[url] =
            origins.some(function (origin) { return Object(string["a" /* isMatchingPattern */])(url, origin); }) &&
                !Object(string["a" /* isMatchingPattern */])(url, 'sentry_key');
        return urlMap[url];
    };
    // We want that our users don't have to re-implement shouldCreateSpanForRequest themselves
    // That's why we filter out already unwanted Spans from tracingOrigins
    var shouldCreateSpan = defaultShouldCreateSpan;
    if (typeof shouldCreateSpanForRequest === 'function') {
        shouldCreateSpan = function (url) {
            return defaultShouldCreateSpan(url) && shouldCreateSpanForRequest(url);
        };
    }
    var spans = {};
    if (traceFetch) {
        Object(instrument["a" /* addInstrumentationHandler */])({
            callback: function (handlerData) {
                _fetchCallback(handlerData, shouldCreateSpan, spans);
            },
            type: 'fetch',
        });
    }
    if (traceXHR) {
        Object(instrument["a" /* addInstrumentationHandler */])({
            callback: function (handlerData) {
                xhrCallback(handlerData, shouldCreateSpan, spans);
            },
            type: 'xhr',
        });
    }
}
/**
 * Create and track fetch request spans
 */
function _fetchCallback(handlerData, shouldCreateSpan, spans) {
    if (!handlerData.fetchData || !shouldCreateSpan(handlerData.fetchData.url)) {
        return;
    }
    if (handlerData.endTimestamp && handlerData.fetchData.__span) {
        var span = spans[handlerData.fetchData.__span];
        if (span) {
            var response = handlerData.response;
            if (response) {
                span.setHttpStatus(response.status);
            }
            span.finish();
            // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
            delete spans[handlerData.fetchData.__span];
        }
        return;
    }
    var activeTransaction = Object(utils["b" /* getActiveTransaction */])();
    if (activeTransaction) {
        var span = activeTransaction.startChild({
            data: Object(tslib_es6["a" /* __assign */])(Object(tslib_es6["a" /* __assign */])({}, handlerData.fetchData), { type: 'fetch' }),
            description: handlerData.fetchData.method + " " + handlerData.fetchData.url,
            op: 'http',
        });
        handlerData.fetchData.__span = span.spanId;
        spans[span.spanId] = span;
        var request = (handlerData.args[0] = handlerData.args[0]);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        var options = (handlerData.args[1] = handlerData.args[1] || {});
        var headers = options.headers;
        if (Object(is["g" /* isInstanceOf */])(request, Request)) {
            headers = request.headers;
        }
        if (headers) {
            // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
            if (typeof headers.append === 'function') {
                // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
                headers.append('sentry-trace', span.toTraceparent());
            }
            else if (Array.isArray(headers)) {
                headers = Object(tslib_es6["e" /* __spread */])(headers, [['sentry-trace', span.toTraceparent()]]);
            }
            else {
                headers = Object(tslib_es6["a" /* __assign */])(Object(tslib_es6["a" /* __assign */])({}, headers), { 'sentry-trace': span.toTraceparent() });
            }
        }
        else {
            headers = { 'sentry-trace': span.toTraceparent() };
        }
        options.headers = headers;
    }
}
/**
 * Create and track xhr request spans
 */
function xhrCallback(handlerData, shouldCreateSpan, spans) {
    if (!handlerData || !handlerData.xhr || !handlerData.xhr.__sentry_xhr__) {
        return;
    }
    var xhr = handlerData.xhr.__sentry_xhr__;
    if (!shouldCreateSpan(xhr.url)) {
        return;
    }
    // We only capture complete, non-sentry requests
    if (handlerData.xhr.__sentry_own_request__) {
        return;
    }
    if (handlerData.endTimestamp && handlerData.xhr.__sentry_xhr_span_id__) {
        var span = spans[handlerData.xhr.__sentry_xhr_span_id__];
        if (span) {
            span.setData('url', xhr.url);
            span.setData('method', xhr.method);
            span.setHttpStatus(xhr.status_code);
            span.finish();
            // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
            delete spans[handlerData.xhr.__sentry_xhr_span_id__];
        }
        return;
    }
    var activeTransaction = Object(utils["b" /* getActiveTransaction */])();
    if (activeTransaction) {
        var span = activeTransaction.startChild({
            data: Object(tslib_es6["a" /* __assign */])(Object(tslib_es6["a" /* __assign */])({}, xhr.data), { type: 'xhr' }),
            description: xhr.method + " " + xhr.url,
            op: 'http',
        });
        handlerData.xhr.__sentry_xhr_span_id__ = span.spanId;
        spans[handlerData.xhr.__sentry_xhr_span_id__] = span;
        if (handlerData.xhr.setRequestHeader) {
            try {
                handlerData.xhr.setRequestHeader('sentry-trace', span.toTraceparent());
            }
            catch (_) {
                // Error: InvalidStateError: Failed to execute 'setRequestHeader' on 'XMLHttpRequest': The object's state must be OPENED.
            }
        }
    }
}
//# sourceMappingURL=request.js.map
// CONCATENATED MODULE: ./node_modules/@sentry/tracing/esm/browser/router.js

var router_global = Object(misc["e" /* getGlobalObject */])();
/**
 * Default function implementing pageload and navigation transactions
 */
function defaultRoutingInstrumentation(startTransaction, startTransactionOnPageLoad, startTransactionOnLocationChange) {
    if (startTransactionOnPageLoad === void 0) { startTransactionOnPageLoad = true; }
    if (startTransactionOnLocationChange === void 0) { startTransactionOnLocationChange = true; }
    if (!router_global || !router_global.location) {
        logger["a" /* logger */].warn('Could not initialize routing instrumentation due to invalid location');
        return;
    }
    var startingUrl = router_global.location.href;
    var activeTransaction;
    if (startTransactionOnPageLoad) {
        activeTransaction = startTransaction({ name: router_global.location.pathname, op: 'pageload' });
    }
    if (startTransactionOnLocationChange) {
        Object(instrument["a" /* addInstrumentationHandler */])({
            callback: function (_a) {
                var to = _a.to, from = _a.from;
                /**
                 * This early return is there to account for some cases where a navigation transaction starts right after
                 * long-running pageload. We make sure that if `from` is undefined and a valid `startingURL` exists, we don't
                 * create an uneccessary navigation transaction.
                 *
                 * This was hard to duplicate, but this behavior stopped as soon as this fix was applied. This issue might also
                 * only be caused in certain development environments where the usage of a hot module reloader is causing
                 * errors.
                 */
                if (from === undefined && startingUrl && startingUrl.indexOf(to) !== -1) {
                    startingUrl = undefined;
                    return;
                }
                if (from !== to) {
                    startingUrl = undefined;
                    if (activeTransaction) {
                        logger["a" /* logger */].log("[Tracing] Finishing current transaction with op: " + activeTransaction.op);
                        // If there's an open transaction on the scope, we need to finish it before creating an new one.
                        activeTransaction.finish();
                    }
                    activeTransaction = startTransaction({ name: router_global.location.pathname, op: 'navigation' });
                }
            },
            type: 'history',
        });
    }
}
/** default implementation of Browser Tracing before navigate */
function defaultBeforeNavigate(context) {
    return context;
}
//# sourceMappingURL=router.js.map
// CONCATENATED MODULE: ./node_modules/@sentry/tracing/esm/browser/browsertracing.js










var DEFAULT_MAX_TRANSACTION_DURATION_SECONDS = 600;
var DEFAULT_BROWSER_TRACING_OPTIONS = Object(tslib_es6["a" /* __assign */])({ beforeNavigate: defaultBeforeNavigate, idleTimeout: idletransaction["a" /* DEFAULT_IDLE_TIMEOUT */], markBackgroundTransactions: true, maxTransactionDuration: DEFAULT_MAX_TRANSACTION_DURATION_SECONDS, routingInstrumentation: defaultRoutingInstrumentation, startTransactionOnLocationChange: true, startTransactionOnPageLoad: true }, defaultRequestInstrumentionOptions);
/**
 * The Browser Tracing integration automatically instruments browser pageload/navigation
 * actions as transactions, and captures requests, metrics and errors as spans.
 *
 * The integration can be configured with a variety of options, and can be extended to use
 * any routing library. This integration uses {@see IdleTransaction} to create transactions.
 */
var browsertracing_BrowserTracing = /** @class */ (function () {
    function BrowserTracing(_options) {
        /**
         * @inheritDoc
         */
        this.name = BrowserTracing.id;
        this._metrics = new metrics_MetricsInstrumentation();
        this._emitOptionsWarning = false;
        var tracingOrigins = defaultRequestInstrumentionOptions.tracingOrigins;
        // NOTE: Logger doesn't work in constructors, as it's initialized after integrations instances
        if (_options &&
            _options.tracingOrigins &&
            Array.isArray(_options.tracingOrigins) &&
            _options.tracingOrigins.length !== 0) {
            tracingOrigins = _options.tracingOrigins;
        }
        else {
            this._emitOptionsWarning = true;
        }
        this.options = Object(tslib_es6["a" /* __assign */])(Object(tslib_es6["a" /* __assign */])(Object(tslib_es6["a" /* __assign */])({}, DEFAULT_BROWSER_TRACING_OPTIONS), _options), { tracingOrigins: tracingOrigins });
    }
    /**
     * @inheritDoc
     */
    BrowserTracing.prototype.setupOnce = function (_, getCurrentHub) {
        var _this = this;
        this._getCurrentHub = getCurrentHub;
        if (this._emitOptionsWarning) {
            logger["a" /* logger */].warn('[Tracing] You need to define `tracingOrigins` in the options. Set an array of urls or patterns to trace.');
            logger["a" /* logger */].warn("[Tracing] We added a reasonable default for you: " + defaultRequestInstrumentionOptions.tracingOrigins);
        }
        // eslint-disable-next-line @typescript-eslint/unbound-method
        var _a = this.options, routingInstrumentation = _a.routingInstrumentation, startTransactionOnLocationChange = _a.startTransactionOnLocationChange, startTransactionOnPageLoad = _a.startTransactionOnPageLoad, markBackgroundTransactions = _a.markBackgroundTransactions, traceFetch = _a.traceFetch, traceXHR = _a.traceXHR, tracingOrigins = _a.tracingOrigins, shouldCreateSpanForRequest = _a.shouldCreateSpanForRequest;
        routingInstrumentation(function (context) { return _this._createRouteTransaction(context); }, startTransactionOnPageLoad, startTransactionOnLocationChange);
        if (markBackgroundTransactions) {
            registerBackgroundTabDetection();
        }
        registerRequestInstrumentation({ traceFetch: traceFetch, traceXHR: traceXHR, tracingOrigins: tracingOrigins, shouldCreateSpanForRequest: shouldCreateSpanForRequest });
    };
    /** Create routing idle transaction. */
    BrowserTracing.prototype._createRouteTransaction = function (context) {
        var _this = this;
        if (!this._getCurrentHub) {
            logger["a" /* logger */].warn("[Tracing] Did not create " + context.op + " transaction because _getCurrentHub is invalid.");
            return undefined;
        }
        // eslint-disable-next-line @typescript-eslint/unbound-method
        var _a = this.options, beforeNavigate = _a.beforeNavigate, idleTimeout = _a.idleTimeout, maxTransactionDuration = _a.maxTransactionDuration;
        // if beforeNavigate returns undefined, we should not start a transaction.
        var ctx = beforeNavigate(Object(tslib_es6["a" /* __assign */])(Object(tslib_es6["a" /* __assign */])(Object(tslib_es6["a" /* __assign */])({}, context), getHeaderContext()), { trimEnd: true }));
        if (ctx === undefined) {
            logger["a" /* logger */].log("[Tracing] Did not create " + context.op + " idleTransaction due to beforeNavigate");
            return undefined;
        }
        var hub = this._getCurrentHub();
        logger["a" /* logger */].log("[Tracing] starting " + ctx.op + " idleTransaction on scope");
        var idleTransaction = Object(hubextensions["b" /* startIdleTransaction */])(hub, ctx, idleTimeout, true);
        idleTransaction.registerBeforeFinishCallback(function (transaction, endTimestamp) {
            _this._metrics.addPerformanceEntries(transaction);
            adjustTransactionDuration(Object(utils["e" /* secToMs */])(maxTransactionDuration), transaction, endTimestamp);
        });
        return idleTransaction;
    };
    /**
     * @inheritDoc
     */
    BrowserTracing.id = 'BrowserTracing';
    return BrowserTracing;
}());

/**
 * Gets transaction context from a sentry-trace meta.
 *
 * @returns Transaction context data from the header or undefined if there's no header or the header is malformed
 */
function getHeaderContext() {
    var header = getMetaContent('sentry-trace');
    if (header) {
        return Object(utils["a" /* extractTraceparentData */])(header);
    }
    return undefined;
}
/** Returns the value of a meta tag */
function getMetaContent(metaName) {
    var el = document.querySelector("meta[name=" + metaName + "]");
    return el ? el.getAttribute('content') : null;
}
/** Adjusts transaction value based on max transaction duration */
function adjustTransactionDuration(maxDuration, transaction, endTimestamp) {
    var diff = endTimestamp - transaction.startTimestamp;
    var isOutdatedTransaction = endTimestamp && (diff > maxDuration || diff < 0);
    if (isOutdatedTransaction) {
        transaction.setStatus(spanstatus["a" /* SpanStatus */].DeadlineExceeded);
        transaction.setTag('maxTransactionDurationExceeded', 'true');
    }
}
//# sourceMappingURL=browsertracing.js.map
// CONCATENATED MODULE: ./node_modules/@sentry/tracing/esm/integrations/express.js

/**
 * Express integration
 *
 * Provides an request and error handler for Express framework
 * as well as tracing capabilities
 */
var express_Express = /** @class */ (function () {
    /**
     * @inheritDoc
     */
    function Express(options) {
        if (options === void 0) { options = {}; }
        /**
         * @inheritDoc
         */
        this.name = Express.id;
        this._app = options.app;
    }
    /**
     * @inheritDoc
     */
    Express.prototype.setupOnce = function () {
        if (!this._app) {
            logger["a" /* logger */].error('ExpressIntegration is missing an Express instance');
            return;
        }
        instrumentMiddlewares(this._app);
    };
    /**
     * @inheritDoc
     */
    Express.id = 'Express';
    return Express;
}());

/**
 * Wraps original middleware function in a tracing call, which stores the info about the call as a span,
 * and finishes it once the middleware is done invoking.
 *
 * Express middlewares have 3 various forms, thus we have to take care of all of them:
 * // sync
 * app.use(function (req, res) { ... })
 * // async
 * app.use(function (req, res, next) { ... })
 * // error handler
 * app.use(function (err, req, res, next) { ... })
 */
// eslint-disable-next-line @typescript-eslint/ban-types
function wrap(fn) {
    var arity = fn.length;
    switch (arity) {
        case 2: {
            return function (_req, res) {
                var transaction = res.__sentry_transaction;
                if (transaction) {
                    var span_1 = transaction.startChild({
                        description: fn.name,
                        op: 'middleware',
                    });
                    res.once('finish', function () {
                        span_1.finish();
                    });
                }
                // eslint-disable-next-line prefer-rest-params
                return fn.apply(this, arguments);
            };
        }
        case 3: {
            return function (req, res, next) {
                var transaction = res.__sentry_transaction;
                var span = transaction &&
                    transaction.startChild({
                        description: fn.name,
                        op: 'middleware',
                    });
                fn.call(this, req, res, function () {
                    if (span) {
                        span.finish();
                    }
                    // eslint-disable-next-line prefer-rest-params
                    return next.apply(this, arguments);
                });
            };
        }
        case 4: {
            return function (err, req, res, next) {
                var transaction = res.__sentry_transaction;
                var span = transaction &&
                    transaction.startChild({
                        description: fn.name,
                        op: 'middleware',
                    });
                fn.call(this, err, req, res, function () {
                    if (span) {
                        span.finish();
                    }
                    // eslint-disable-next-line prefer-rest-params
                    return next.apply(this, arguments);
                });
            };
        }
        default: {
            throw new Error("Express middleware takes 2-4 arguments. Got: " + arity);
        }
    }
}
/**
 * Takes all the function arguments passed to the original `app.use` call
 * and wraps every function, as well as array of functions with a call to our `wrap` method.
 * We have to take care of the arrays as well as iterate over all of the arguments,
 * as `app.use` can accept middlewares in few various forms.
 *
 * app.use([<path>], <fn>)
 * app.use([<path>], <fn>, ...<fn>)
 * app.use([<path>], ...<fn>[])
 */
function wrapUseArgs(args) {
    return Array.from(args).map(function (arg) {
        if (typeof arg === 'function') {
            return wrap(arg);
        }
        if (Array.isArray(arg)) {
            return arg.map(function (a) {
                if (typeof a === 'function') {
                    return wrap(a);
                }
                return a;
            });
        }
        return arg;
    });
}
/**
 * Patches original app.use to utilize our tracing functionality
 */
function instrumentMiddlewares(app) {
    // eslint-disable-next-line @typescript-eslint/unbound-method
    var originalAppUse = app.use;
    app.use = function () {
        // eslint-disable-next-line prefer-rest-params
        return originalAppUse.apply(this, wrapUseArgs(arguments));
    };
    return app;
}
//# sourceMappingURL=express.js.map
// CONCATENATED MODULE: ./node_modules/@sentry/tracing/esm/integrations/index.js

//# sourceMappingURL=index.js.map
// CONCATENATED MODULE: ./node_modules/@sentry/tracing/esm/index.js




var Integrations = Object(tslib_es6["a" /* __assign */])(Object(tslib_es6["a" /* __assign */])({}, integrations_namespaceObject), { BrowserTracing: browsertracing_BrowserTracing });




// We are patching the global object with our hub extension methods
Object(hubextensions["a" /* addExtensionMethods */])();


//# sourceMappingURL=index.js.map

/***/ }),

/***/ "bju/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SpanStatus; });
/** The status of an Span. */
// eslint-disable-next-line import/export
var SpanStatus;
(function (SpanStatus) {
    /** The operation completed successfully. */
    SpanStatus["Ok"] = "ok";
    /** Deadline expired before operation could complete. */
    SpanStatus["DeadlineExceeded"] = "deadline_exceeded";
    /** 401 Unauthorized (actually does mean unauthenticated according to RFC 7235) */
    SpanStatus["Unauthenticated"] = "unauthenticated";
    /** 403 Forbidden */
    SpanStatus["PermissionDenied"] = "permission_denied";
    /** 404 Not Found. Some requested entity (file or directory) was not found. */
    SpanStatus["NotFound"] = "not_found";
    /** 429 Too Many Requests */
    SpanStatus["ResourceExhausted"] = "resource_exhausted";
    /** Client specified an invalid argument. 4xx. */
    SpanStatus["InvalidArgument"] = "invalid_argument";
    /** 501 Not Implemented */
    SpanStatus["Unimplemented"] = "unimplemented";
    /** 503 Service Unavailable */
    SpanStatus["Unavailable"] = "unavailable";
    /** Other/generic 5xx. */
    SpanStatus["InternalError"] = "internal_error";
    /** Unknown. Any non-standard HTTP status code. */
    SpanStatus["UnknownError"] = "unknown_error";
    /** The operation was cancelled (typically by the user). */
    SpanStatus["Cancelled"] = "cancelled";
    /** Already exists (409) */
    SpanStatus["AlreadyExists"] = "already_exists";
    /** Operation was rejected because the system is not in a state required for the operation's */
    SpanStatus["FailedPrecondition"] = "failed_precondition";
    /** The operation was aborted, typically due to a concurrency issue. */
    SpanStatus["Aborted"] = "aborted";
    /** Operation was attempted past the valid range. */
    SpanStatus["OutOfRange"] = "out_of_range";
    /** Unrecoverable data loss or corruption */
    SpanStatus["DataLoss"] = "data_loss";
})(SpanStatus || (SpanStatus = {}));
// eslint-disable-next-line @typescript-eslint/no-namespace, import/export
(function (SpanStatus) {
    /**
     * Converts a HTTP status code into a {@link SpanStatus}.
     *
     * @param httpStatus The HTTP response status code.
     * @returns The span status or {@link SpanStatus.UnknownError}.
     */
    function fromHttpCode(httpStatus) {
        if (httpStatus < 400) {
            return SpanStatus.Ok;
        }
        if (httpStatus >= 400 && httpStatus < 500) {
            switch (httpStatus) {
                case 401:
                    return SpanStatus.Unauthenticated;
                case 403:
                    return SpanStatus.PermissionDenied;
                case 404:
                    return SpanStatus.NotFound;
                case 409:
                    return SpanStatus.AlreadyExists;
                case 413:
                    return SpanStatus.FailedPrecondition;
                case 429:
                    return SpanStatus.ResourceExhausted;
                default:
                    return SpanStatus.InvalidArgument;
            }
        }
        if (httpStatus >= 500 && httpStatus < 600) {
            switch (httpStatus) {
                case 501:
                    return SpanStatus.Unimplemented;
                case 503:
                    return SpanStatus.Unavailable;
                case 504:
                    return SpanStatus.DeadlineExceeded;
                default:
                    return SpanStatus.InternalError;
            }
        }
        return SpanStatus.UnknownError;
    }
    SpanStatus.fromHttpCode = fromHttpCode;
})(SpanStatus || (SpanStatus = {}));
//# sourceMappingURL=spanstatus.js.map

/***/ }),

/***/ "moWa":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getShimmerStyles; });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("q1tI");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var styled_jsx_style__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("MX0m");
/* harmony import */ var styled_jsx_style__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(styled_jsx_style__WEBPACK_IMPORTED_MODULE_1__);

var __jsx = react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement;

var getShimmerStyles = function getShimmerStyles() {
  return {
    styles: __jsx(styled_jsx_style__WEBPACK_IMPORTED_MODULE_1___default.a, {
      id: "3121280935"
    }, ["@-webkit-keyframes placeHolderShimmer-jsx-3121280935{0%{background-position:-468px 0;}100%{background-position:468px 0;}}", "@keyframes placeHolderShimmer-jsx-3121280935{0%{background-position:-468px 0;}100%{background-position:468px 0;}}", ".shimmer{color:#eeeeef;-webkit-animation-duration:2s;animation-duration:2s;-webkit-animation-fill-mode:forwards;animation-fill-mode:forwards;-webkit-animation-iteration-count:infinite;animation-iteration-count:infinite;-webkit-animation-name:placeHolderShimmer-jsx-3121280935;animation-name:placeHolderShimmer-jsx-3121280935;-webkit-animation-timing-function:linear;animation-timing-function:linear;background:#f6f7f8;background:linear-gradient( 90deg, #d5d5d5 10%, #f5f5f5 50%, #d5d5d5 100% );background-size:800px 104px;position:relative;}"]),
    className: "jsx-3121280935"
  };
};

/***/ }),

/***/ "xUM1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getOverrideStyles; });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("q1tI");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var styled_jsx_style__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("MX0m");
/* harmony import */ var styled_jsx_style__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(styled_jsx_style__WEBPACK_IMPORTED_MODULE_1__);

var __jsx = react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement;

var getOverrideStyles = function getOverrideStyles(theme) {
  return {
    styles: __jsx(styled_jsx_style__WEBPACK_IMPORTED_MODULE_1___default.a, {
      id: "3765595179",
      dynamic: [theme["color-primary"], theme["color-primary"], theme["color-primary"], theme["color-primary"], theme["color-primary"], theme["color-primary"], theme["color-primary"]]
    }, [".rc-checkbox{width:18px;height:18px;white-space:nowrap;cursor:pointer;outline:none;display:inline-block;position:relative;line-height:1;vertical-align:middle;}", ".rc-checkbox-input{width:18px;height:18px;position:absolute;left:0;z-index:9999;cursor:pointer;opacity:0;top:0;bottom:0;right:0;}", ".rc-checkbox-inner{position:relative;top:0;left:0;display:inline-block;width:18px;height:18px;border-width:1px;border-style:solid;border-radius:3px;border-color:#d9d9d9;background-color:#ffffff;-webkit-transition:border-color 0.3s cubic-bezier(0.68,-0.55,0.27,1.55), background-color 0.3s cubic-bezier(0.68,-0.55,0.27,1.55);-webkit-transition:border-color 0.3s cubic-bezier(0.68,-0.55,0.27,1.55), background-color 0.3s cubic-bezier(0.68,-0.55,0.27,1.55);transition:border-color 0.3s cubic-bezier(0.68,-0.55,0.27,1.55), background-color 0.3s cubic-bezier(0.68,-0.55,0.27,1.55);}", ".rc-checkbox-checked .rc-checkbox-inner{border-color:".concat(theme["color-primary"], ";background-color:").concat(theme["color-primary"], ";}"), ".rc-checkbox-inner:after,.rc-checkbox-checked .rc-checkbox-inner:after{webkit-transform:rotate(45deg);-webkit-transform:rotate(45deg);-ms-transform:rotate(45deg);transform:rotate(45deg);position:absolute;left:6px;top:1px;display:table;width:4px;height:10px;border:3px solid #ffffff;border-top:0;border-left:0;content:\" \";-webkit-animation-timing-function:cubic-bezier(0.68,-0.55,0.27,1.55);-webkit-animation-timing-function:cubic-bezier(0.68,-0.55,0.27,1.55);animation-timing-function:cubic-bezier(0.68,-0.55,0.27,1.55);-webkit-animation-duration:0.3s;-webkit-animation-duration:0.3s;animation-duration:0.3s;-webkit-animation-name:amCheckboxOut;-webkit-animation-name:amCheckboxOut-__jsx-style-dynamic-selector;animation-name:amCheckboxOut-__jsx-style-dynamic-selector;}", ".rc-checkbox:hover .rc-checkbox-inner,.rc-checkbox-input:focus + .rc-checkbox-inner{border-color:".concat(theme["color-primary"], ";border-top-color:").concat(theme["color-primary"], ";border-right-color:").concat(theme["color-primary"], ";border-bottom-color:").concat(theme["color-primary"], ";border-left-color:").concat(theme["color-primary"], ";}")]),
    className: styled_jsx_style__WEBPACK_IMPORTED_MODULE_1___default.a.dynamic([["3765595179", [theme["color-primary"], theme["color-primary"], theme["color-primary"], theme["color-primary"], theme["color-primary"], theme["color-primary"], theme["color-primary"]]]])
  };
};

/***/ }),

/***/ "zTMq":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "zaks":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ })

},[[0,1,2,3,4,0,11]]]);